
export enum Enum1153 {
    /**
    * Order acknowledgement document identifier
    */
    OrderAcknowledgementDocumentIdentifier = "AAA",
    /**
    * Proforma invoice document identifier
    */
    ProformaInvoiceDocumentIdentifier = "AAB",
    /**
    * Documentary credit identifier
    */
    DocumentaryCreditIdentifier = "AAC",
    /**
    * Contract document addendum identifier
    */
    ContractDocumentAddendumIdentifier = "AAD",
    /**
    * Goods declaration number
    */
    GoodsDeclarationNumber = "AAE",
    /**
    * Debit card number
    */
    DebitCardNumber = "AAF",
    /**
    * Offer number
    */
    OfferNumber = "AAG",
    /**
    * Bank's batch interbank transaction reference number
    */
    BanksBatchInterbankTransactionReferenceNumber = "AAH",
    /**
    * Bank's individual interbank transaction reference number
    */
    BanksIndividualInterbankTransactionReferenceNumber = "AAI",
    /**
    * Delivery order number
    */
    DeliveryOrderNumber = "AAJ",
    /**
    * Despatch advice number
    */
    DespatchAdviceNumber = "AAK",
    /**
    * Drawing number
    */
    DrawingNumber = "AAL",
    /**
    * Waybill number
    */
    WaybillNumber = "AAM",
    /**
    * Delivery schedule number
    */
    DeliveryScheduleNumber = "AAN",
    /**
    * Consignment identifier, consignee assigned
    */
    ConsignmentIdentifierConsigneeAssigned = "AAO",
    /**
    * Partial shipment identifier
    */
    PartialShipmentIdentifier = "AAP",
    /**
    * Transport equipment identifier
    */
    TransportEquipmentIdentifier = "AAQ",
    /**
    * Municipality assigned business registry number
    */
    MunicipalityAssignedBusinessRegistryNumber = "AAR",
    /**
    * Transport contract document identifier
    */
    TransportContractDocumentIdentifier = "AAS",
    /**
    * Master label number
    */
    MasterLabelNumber = "AAT",
    /**
    * Despatch note document identifier
    */
    DespatchNoteDocumentIdentifier = "AAU",
    /**
    * Enquiry number
    */
    EnquiryNumber = "AAV",
    /**
    * Docket number
    */
    DocketNumber = "AAW",
    /**
    * Civil action number
    */
    CivilActionNumber = "AAX",
    /**
    * Carrier's agent reference number
    */
    CarriersAgentReferenceNumber = "AAY",
    /**
    * Standard Carrier Alpha Code (SCAC) number
    */
    StandardCarrierAlphaCodeScacNumber = "AAZ",
    /**
    * Customs valuation decision number
    */
    CustomsValuationDecisionNumber = "ABA",
    /**
    * End use authorization number
    */
    EndUseAuthorizationNumber = "ABB",
    /**
    * Anti-dumping case number
    */
    AntiDumpingCaseNumber = "ABC",
    /**
    * Customs tariff number
    */
    CustomsTariffNumber = "ABD",
    /**
    * Declarant's reference number
    */
    DeclarantsReferenceNumber = "ABE",
    /**
    * Repair estimate number
    */
    RepairEstimateNumber = "ABF",
    /**
    * Customs decision request number
    */
    CustomsDecisionRequestNumber = "ABG",
    /**
    * Sub-house bill of lading number
    */
    SubHouseBillLadingNumber = "ABH",
    /**
    * Tax payment identifier
    */
    TaxPaymentIdentifier = "ABI",
    /**
    * Quota number
    */
    QuotaNumber = "ABJ",
    /**
    * Transit (onward carriage) guarantee (bond) number
    */
    TransitOnwardCarriageGuaranteeBondNumber = "ABK",
    /**
    * Customs guarantee number
    */
    CustomsGuaranteeNumber = "ABL",
    /**
    * Replacing part number
    */
    ReplacingPartNumber = "ABM",
    /**
    * Seller's catalogue number
    */
    SellersCatalogueNumber = "ABN",
    /**
    * Originator's reference
    */
    OriginatorsReference = "ABO",
    /**
    * Declarant's Customs identity number
    */
    DeclarantsCustomsIdentityNumber = "ABP",
    /**
    * Importer reference number
    */
    ImporterReferenceNumber = "ABQ",
    /**
    * Export clearance instruction reference number
    */
    ExportClearanceInstructionReferenceNumber = "ABR",
    /**
    * Import clearance instruction reference number
    */
    ImportClearanceInstructionReferenceNumber = "ABS",
    /**
    * Goods declaration document identifier, Customs
    */
    GoodsDeclarationDocumentIdentifierCustoms = "ABT",
    /**
    * Article number
    */
    ArticleNumber = "ABU",
    /**
    * Intra-plant routing
    */
    IntraPlantRouting = "ABV",
    /**
    * Stock keeping unit number
    */
    StockKeepingUnitNumber = "ABW",
    /**
    * Text Element Identifier deletion reference
    */
    TextElementIdentifierDeletionReference = "ABX",
    /**
    * Allotment identification (Air)
    */
    AllotmentIdentificationAir = "ABY",
    /**
    * Vehicle licence number
    */
    VehicleLicenceNumber = "ABZ",
    /**
    *  Air cargo transfer manifest
    */
    AirCargoTransferManifest = "AC",
    /**
    * Cargo acceptance order reference number
    */
    CargoAcceptanceOrderReferenceNumber = "ACA",
    /**
    * US government agency number
    */
    UsGovernmentAgencyNumber = "ACB",
    /**
    * Shipping unit identification
    */
    ShippingUnitIdentification = "ACC",
    /**
    * Additional reference number
    */
    AdditionalReferenceNumber = "ACD",
    /**
    * Related document number
    */
    RelatedDocumentNumber = "ACE",
    /**
    * Addressee reference
    */
    AddresseeReference = "ACF",
    /**
    * ATA carnet number
    */
    AtaCarnetNumber = "ACG",
    /**
    * Packaging unit identification
    */
    PackagingUnitIdentification = "ACH",
    /**
    * Outerpackaging unit identification
    */
    OuterpackagingUnitIdentification = "ACI",
    /**
    * Customer material specification number
    */
    CustomerMaterialSpecificationNumber = "ACJ",
    /**
    * Bank reference
    */
    BankReference = "ACK",
    /**
    * Principal reference number
    */
    PrincipalReferenceNumber = "ACL",
    /**
    * Collection advice document identifier
    */
    CollectionAdviceDocumentIdentifier = "ACN",
    /**
    * Iron charge number
    */
    IronChargeNumber = "ACO",
    /**
    * Hot roll number
    */
    HotRollNumber = "ACP",
    /**
    * Cold roll number
    */
    ColdRollNumber = "ACQ",
    /**
    * Railway wagon number
    */
    RailwayWagonNumber = "ACR",
    /**
    * Unique claims reference number of the sender
    */
    UniqueClaimsReferenceNumberSender = "ACT",
    /**
    * Loss/event number
    */
    LossEventNumber = "ACU",
    /**
    * Estimate order reference number
    */
    EstimateOrderReferenceNumber = "ACV",
    /**
    * Reference number to previous message
    */
    ReferenceNumberToPreviousMessage = "ACW",
    /**
    * Banker's acceptance
    */
    BankersAcceptance = "ACX",
    /**
    * Duty memo number
    */
    DutyMemoNumber = "ACY",
    /**
    * Equipment transport charge number
    */
    EquipmentTransportChargeNumber = "ACZ",
    /**
    * Buyer's item number
    */
    BuyersItemNumber = "ADA",
    /**
    * Matured certificate of deposit
    */
    MaturedCertificateDeposit = "ADB",
    /**
    * Loan
    */
    Loan = "ADC",
    /**
    * Analysis number/test number
    */
    AnalysisNumberTestNumber = "ADD",
    /**
    * Account number
    */
    AccountNumber = "ADE",
    /**
    * Treaty number
    */
    TreatyNumber = "ADF",
    /**
    * Catastrophe number
    */
    CatastropheNumber = "ADG",
    /**
    * Bureau signing (statement reference)
    */
    BureauSigningStatementReference = "ADI",
    /**
    * Company / syndicate reference 1
    */
    CompanySyndicateReference1 = "ADJ",
    /**
    * Company / syndicate reference 2
    */
    CompanySyndicateReference2 = "ADK",
    /**
    * Ordering customer consignment reference number
    */
    OrderingCustomerConsignmentReferenceNumber = "ADL",
    /**
    * Shipowner's authorization number
    */
    ShipownersAuthorizationNumber = "ADM",
    /**
    * Inland transport order number
    */
    InlandTransportOrderNumber = "ADN",
    /**
    * Container work order reference number
    */
    ContainerWorkOrderReferenceNumber = "ADO",
    /**
    * Statement number
    */
    StatementNumber = "ADP",
    /**
    * Unique market reference
    */
    UniqueMarketReference = "ADQ",
    /**
    * Group accounting
    */
    GroupAccounting = "ADT",
    /**
    * Broker reference 1
    */
    BrokerReference1 = "ADU",
    /**
    * Broker reference 2
    */
    BrokerReference2 = "ADV",
    /**
    * Lloyd's claims office reference
    */
    LloydsClaimsOfficeReference = "ADW",
    /**
    * Secure delivery terms and conditions agreement reference
    */
    SecureDeliveryTermsAndConditionsAgreementReference = "ADX",
    /**
    * Report number
    */
    ReportNumber = "ADY",
    /**
    * Trader account number
    */
    TraderAccountNumber = "ADZ",
    /**
    *  Authorization for expense (AFE) number
    */
    AuthorizationForExpenseAfeNumber = "AE",
    /**
    * Government agency reference number
    */
    GovernmentAgencyReferenceNumber = "AEA",
    /**
    * Assembly number
    */
    AssemblyNumber = "AEB",
    /**
    * Symbol number
    */
    SymbolNumber = "AEC",
    /**
    * Commodity number
    */
    CommodityNumber = "AED",
    /**
    * Eur 1 certificate number
    */
    Eur1CertificateNumber = "AEE",
    /**
    * Customer process specification number
    */
    CustomerProcessSpecificationNumber = "AEF",
    /**
    * Customer specification number
    */
    CustomerSpecificationNumber = "AEG",
    /**
    * Applicable instructions or standards
    */
    ApplicableInstructionsOrStandards = "AEH",
    /**
    * Registration number of previous Customs declaration
    */
    RegistrationNumberPreviousCustomsDeclaration = "AEI",
    /**
    * Post-entry reference
    */
    PostEntryReference = "AEJ",
    /**
    * Payment order number
    */
    PaymentOrderNumber = "AEK",
    /**
    * Delivery number (transport)
    */
    DeliveryNumberTransport = "AEL",
    /**
    * Transport route
    */
    TransportRoute = "AEM",
    /**
    * Customer's unit inventory number
    */
    CustomersUnitInventoryNumber = "AEN",
    /**
    * Product reservation number
    */
    ProductReservationNumber = "AEO",
    /**
    * Project number
    */
    ProjectNumber = "AEP",
    /**
    * Drawing list number
    */
    DrawingListNumber = "AEQ",
    /**
    * Project specification number
    */
    ProjectSpecificationNumber = "AER",
    /**
    * Primary reference
    */
    PrimaryReference = "AES",
    /**
    * Request for cancellation number
    */
    RequestForCancellationNumber = "AET",
    /**
    * Supplier's control number
    */
    SuppliersControlNumber = "AEU",
    /**
    * Shipping note number
    */
    ShippingNoteNumber = "AEV",
    /**
    * Empty container bill number
    */
    EmptyContainerBillNumber = "AEW",
    /**
    * Non-negotiable maritime transport document number
    */
    NonNegotiableMaritimeTransportDocumentNumber = "AEX",
    /**
    * Substitute air waybill number
    */
    SubstituteAirWaybillNumber = "AEY",
    /**
    * Despatch note (post parcels) number
    */
    DespatchNotePostParcelsNumber = "AEZ",
    /**
    *  Airlines flight identification number
    */
    AirlinesFlightIdentificationNumber = "AF",
    /**
    * Through bill of lading number
    */
    ThroughBillLadingNumber = "AFA",
    /**
    * Cargo manifest number
    */
    CargoManifestNumber = "AFB",
    /**
    * Bordereau number
    */
    BordereauNumber = "AFC",
    /**
    * Customs item number
    */
    CustomsItemNumber = "AFD",
    /**
    * Export Control Commodity number (ECCN)
    */
    ExportControlCommodityNumberEccn = "AFE",
    /**
    * Marking/label reference
    */
    MarkingLabelReference = "AFF",
    /**
    * Tariff number
    */
    TariffNumber = "AFG",
    /**
    * Replenishment purchase order number
    */
    ReplenishmentPurchaseOrderNumber = "AFH",
    /**
    * Immediate transportation no. for in bond movement
    */
    ImmediateTransportationNoForInBondMovement = "AFI",
    /**
    * Transportation exportation no. for in bond movement
    */
    TransportationExportationNoForInBondMovement = "AFJ",
    /**
    * Immediate exportation no. for in bond movement
    */
    ImmediateExportationNoForInBondMovement = "AFK",
    /**
    * Associated invoices
    */
    AssociatedInvoices = "AFL",
    /**
    * Secondary Customs reference
    */
    SecondaryCustomsReference = "AFM",
    /**
    * Account party's reference
    */
    AccountPartysReference = "AFN",
    /**
    * Beneficiary's reference
    */
    BeneficiarysReference = "AFO",
    /**
    * Second beneficiary's reference
    */
    SecondBeneficiarysReference = "AFP",
    /**
    * Applicant's bank reference
    */
    ApplicantsBankReference = "AFQ",
    /**
    * Issuing bank's reference
    */
    IssuingBanksReference = "AFR",
    /**
    * Beneficiary's bank reference
    */
    BeneficiarysBankReference = "AFS",
    /**
    * Direct payment valuation number
    */
    DirectPaymentValuationNumber = "AFT",
    /**
    * Direct payment valuation request number
    */
    DirectPaymentValuationRequestNumber = "AFU",
    /**
    * Quantity valuation number
    */
    QuantityValuationNumber = "AFV",
    /**
    * Quantity valuation request number
    */
    QuantityValuationRequestNumber = "AFW",
    /**
    * Bill of quantities number
    */
    BillQuantitiesNumber = "AFX",
    /**
    * Payment valuation number
    */
    PaymentValuationNumber = "AFY",
    /**
    * Situation number
    */
    SituationNumber = "AFZ",
    /**
    * Agreement to pay number
    */
    AgreementToPayNumber = "AGA",
    /**
    * Contract party reference number
    */
    ContractPartyReferenceNumber = "AGB",
    /**
    * Account party's bank reference
    */
    AccountPartysBankReference = "AGC",
    /**
    * Agent's bank reference
    */
    AgentsBankReference = "AGD",
    /**
    * Agent's reference
    */
    AgentsReference = "AGE",
    /**
    * Applicant's reference
    */
    ApplicantsReference = "AGF",
    /**
    * Dispute number
    */
    DisputeNumber = "AGG",
    /**
    * Credit rating agency's reference number
    */
    CreditRatingAgencysReferenceNumber = "AGH",
    /**
    * Request number
    */
    RequestNumber = "AGI",
    /**
    * Single transaction sequence number
    */
    SingleTransactionSequenceNumber = "AGJ",
    /**
    * Application reference number
    */
    ApplicationReferenceNumber = "AGK",
    /**
    * Delivery verification certificate
    */
    DeliveryVerificationCertificate = "AGL",
    /**
    * Number of temporary importation document
    */
    NumberTemporaryImportationDocument = "AGM",
    /**
    * Reference number quoted on statement
    */
    ReferenceNumberQuotedOnStatement = "AGN",
    /**
    * Sender's reference to the original message
    */
    SendersReferenceToOriginalMessage = "AGO",
    /**
    * Company issued equipment ID
    */
    CompanyIssuedEquipmentId = "AGP",
    /**
    * Domestic flight number
    */
    DomesticFlightNumber = "AGQ",
    /**
    * International flight number
    */
    InternationalFlightNumber = "AGR",
    /**
    * Employer identification number of service bureau
    */
    EmployerIdentificationNumberServiceBureau = "AGS",
    /**
    * Service group identification number
    */
    ServiceGroupIdentificationNumber = "AGT",
    /**
    * Member number
    */
    MemberNumber = "AGU",
    /**
    * Previous member number
    */
    PreviousMemberNumber = "AGV",
    /**
    * Scheme/plan number
    */
    SchemePlanNumber = "AGW",
    /**
    * Previous scheme/plan number
    */
    PreviousSchemePlanNumber = "AGX",
    /**
    * Receiving party's member identification
    */
    ReceivingPartysMemberIdentification = "AGY",
    /**
    * Payroll number
    */
    PayrollNumber = "AGZ",
    /**
    * Packaging specification number
    */
    PackagingSpecificationNumber = "AHA",
    /**
    * Authority issued equipment identification
    */
    AuthorityIssuedEquipmentIdentification = "AHB",
    /**
    * Training flight number
    */
    TrainingFlightNumber = "AHC",
    /**
    * Fund code number
    */
    FundCodeNumber = "AHD",
    /**
    * Signal code number
    */
    SignalCodeNumber = "AHE",
    /**
    * Major force program number
    */
    MajorForceProgramNumber = "AHF",
    /**
    * Nomination number
    */
    NominationNumber = "AHG",
    /**
    * Laboratory registration number
    */
    LaboratoryRegistrationNumber = "AHH",
    /**
    * Transport contract reference number
    */
    TransportContractReferenceNumber = "AHI",
    /**
    * Payee's reference number
    */
    PayeesReferenceNumber = "AHJ",
    /**
    * Payer's reference number
    */
    PayersReferenceNumber = "AHK",
    /**
    * Creditor's reference number
    */
    CreditorsReferenceNumber = "AHL",
    /**
    * Debtor's reference number
    */
    DebtorsReferenceNumber = "AHM",
    /**
    * Joint venture reference number
    */
    JointVentureReferenceNumber = "AHN",
    /**
    * Chamber of Commerce registration number
    */
    ChamberCommerceRegistrationNumber = "AHO",
    /**
    * Tax registration number
    */
    TaxRegistrationNumber = "AHP",
    /**
    * Wool identification number
    */
    WoolIdentificationNumber = "AHQ",
    /**
    * Wool tax reference number
    */
    WoolTaxReferenceNumber = "AHR",
    /**
    * Meat processing establishment registration number
    */
    MeatProcessingEstablishmentRegistrationNumber = "AHS",
    /**
    * Quarantine/treatment status reference number
    */
    QuarantineTreatmentStatusReferenceNumber = "AHT",
    /**
    * Request for quote number
    */
    RequestForQuoteNumber = "AHU",
    /**
    * Manual processing authority number
    */
    ManualProcessingAuthorityNumber = "AHV",
    /**
    * Rate note number
    */
    RateNoteNumber = "AHX",
    /**
    * Freight Forwarder number
    */
    FreightForwarderNumber = "AHY",
    /**
    * Customs release code
    */
    CustomsReleaseCode = "AHZ",
    /**
    * Compliance code number
    */
    ComplianceCodeNumber = "AIA",
    /**
    * Department of transportation bond number
    */
    DepartmentTransportationBondNumber = "AIB",
    /**
    * Export establishment number
    */
    ExportEstablishmentNumber = "AIC",
    /**
    * Certificate of conformity
    */
    CertificateConformity = "AID",
    /**
    * Ministerial certificate of homologation
    */
    MinisterialCertificateHomologation = "AIE",
    /**
    * Previous delivery instruction number
    */
    PreviousDeliveryInstructionNumber = "AIF",
    /**
    * Passport number
    */
    PassportNumber = "AIG",
    /**
    * Common transaction reference number
    */
    CommonTransactionReferenceNumber = "AIH",
    /**
    * Bank's common transaction reference number
    */
    BanksCommonTransactionReferenceNumber = "AII",
    /**
    * Customer's individual transaction reference number
    */
    CustomersIndividualTransactionReferenceNumber = "AIJ",
    /**
    * Bank's individual transaction reference number
    */
    BanksIndividualTransactionReferenceNumber = "AIK",
    /**
    * Customer's common transaction reference number
    */
    CustomersCommonTransactionReferenceNumber = "AIL",
    /**
    * Individual transaction reference number
    */
    IndividualTransactionReferenceNumber = "AIM",
    /**
    * Product sourcing agreement number
    */
    ProductSourcingAgreementNumber = "AIN",
    /**
    * Customs transhipment number
    */
    CustomsTranshipmentNumber = "AIO",
    /**
    * Customs preference inquiry number
    */
    CustomsPreferenceInquiryNumber = "AIP",
    /**
    * Packing plant number
    */
    PackingPlantNumber = "AIQ",
    /**
    * Original certificate number
    */
    OriginalCertificateNumber = "AIR",
    /**
    * Processing plant number
    */
    ProcessingPlantNumber = "AIS",
    /**
    * Slaughter plant number
    */
    SlaughterPlantNumber = "AIT",
    /**
    * Charge card account number
    */
    ChargeCardAccountNumber = "AIU",
    /**
    * Event reference number
    */
    EventReferenceNumber = "AIV",
    /**
    * Transport section reference number
    */
    TransportSectionReferenceNumber = "AIW",
    /**
    * Referred product for mechanical analysis
    */
    ReferredProductForMechanicalAnalysis = "AIX",
    /**
    * Referred product for chemical analysis
    */
    ReferredProductForChemicalAnalysis = "AIY",
    /**
    * Consolidated invoice number
    */
    ConsolidatedInvoiceNumber = "AIZ",
    /**
    * Part reference indicator in a drawing
    */
    PartReferenceIndicatorInADrawing = "AJA",
    /**
    * U.S. Code of Federal Regulations (CFR)
    */
    USCodeFederalRegulationsCfr = "AJB",
    /**
    * Purchasing activity clause number
    */
    PurchasingActivityClauseNumber = "AJC",
    /**
    * U.S. Defense Federal Acquisition Regulation Supplement
    */
    USDefenseFederalAcquisitionRegulationSupplement = "AJD",
    /**
    * Agency clause number
    */
    AgencyClauseNumber = "AJE",
    /**
    * Circular publication number
    */
    CircularPublicationNumber = "AJF",
    /**
    * U.S. Federal Acquisition Regulation
    */
    USFederalAcquisitionRegulation = "AJG",
    /**
    * U.S. General Services Administration Regulation
    */
    USGeneralServicesAdministrationRegulation = "AJH",
    /**
    * U.S. Federal Information Resources Management Regulation
    */
    USFederalInformationResourcesManagementRegulation = "AJI",
    /**
    * Paragraph
    */
    Paragraph = "AJJ",
    /**
    * Special instructions number
    */
    SpecialInstructionsNumber = "AJK",
    /**
    * Site specific procedures, terms, and conditions number
    */
    SiteSpecificProceduresTermsAndConditionsNumber = "AJL",
    /**
    * Master solicitation procedures, terms, and conditions
    */
    MasterSolicitationProceduresTermsAndConditions = "AJM",
    /**
    * U.S. Department of Veterans Affairs Acquisition Regulation
    */
    USDepartmentVeteransAffairsAcquisitionRegulation = "AJN",
    /**
    * Military Interdepartmental Purchase Request (MIPR) number
    */
    MilitaryInterdepartmentalPurchaseRequestMiprNumber = "AJO",
    /**
    * Foreign military sales number
    */
    ForeignMilitarySalesNumber = "AJP",
    /**
    * Defense priorities allocation system priority rating
    */
    DefensePrioritiesAllocationSystemPriorityRating = "AJQ",
    /**
    * Wage determination number
    */
    WageDeterminationNumber = "AJR",
    /**
    * Agreement number
    */
    AgreementNumber = "AJS",
    /**
    * Standard Industry Classification (SIC) number
    */
    StandardIndustryClassificationSicNumber = "AJT",
    /**
    * End item number
    */
    EndItemNumber = "AJU",
    /**
    * Federal supply schedule item number
    */
    FederalSupplyScheduleItemNumber = "AJV",
    /**
    * Technical document number
    */
    TechnicalDocumentNumber = "AJW",
    /**
    * Technical order number
    */
    TechnicalOrderNumber = "AJX",
    /**
    * Suffix
    */
    Suffix = "AJY",
    /**
    * Transportation account number
    */
    TransportationAccountNumber = "AJZ",
    /**
    * Container disposition order reference number
    */
    ContainerDispositionOrderReferenceNumber = "AKA",
    /**
    * Container prefix
    */
    ContainerPrefix = "AKB",
    /**
    * Transport equipment return reference
    */
    TransportEquipmentReturnReference = "AKC",
    /**
    * Transport equipment survey reference
    */
    TransportEquipmentSurveyReference = "AKD",
    /**
    * Transport equipment survey report number
    */
    TransportEquipmentSurveyReportNumber = "AKE",
    /**
    * Transport equipment stuffing order
    */
    TransportEquipmentStuffingOrder = "AKF",
    /**
    * Vehicle Identification Number (VIN)
    */
    VehicleIdentificationNumberVin = "AKG",
    /**
    * Government bill of lading
    */
    GovernmentBillLading = "AKH",
    /**
    * Ordering customer's second reference number
    */
    OrderingCustomersSecondReferenceNumber = "AKI",
    /**
    * Direct debit reference
    */
    DirectDebitReference = "AKJ",
    /**
    * Meter reading at the beginning of the delivery
    */
    MeterReadingAtBeginningDelivery = "AKK",
    /**
    * Meter reading at the end of delivery
    */
    MeterReadingAtEndDelivery = "AKL",
    /**
    * Replenishment purchase order range start number
    */
    ReplenishmentPurchaseOrderRangeStartNumber = "AKM",
    /**
    * Third bank's reference
    */
    ThirdBanksReference = "AKN",
    /**
    * Action authorization number
    */
    ActionAuthorizationNumber = "AKO",
    /**
    * Appropriation number
    */
    AppropriationNumber = "AKP",
    /**
    * Product change authority number
    */
    ProductChangeAuthorityNumber = "AKQ",
    /**
    * General cargo consignment reference number
    */
    GeneralCargoConsignmentReferenceNumber = "AKR",
    /**
    * Catalogue sequence number
    */
    CatalogueSequenceNumber = "AKS",
    /**
    * Forwarding order number
    */
    ForwardingOrderNumber = "AKT",
    /**
    * Transport equipment survey reference number
    */
    TransportEquipmentSurveyReferenceNumber = "AKU",
    /**
    * Lease contract reference
    */
    LeaseContractReference = "AKV",
    /**
    * Transport costs reference number
    */
    TransportCostsReferenceNumber = "AKW",
    /**
    * Transport equipment stripping order
    */
    TransportEquipmentStrippingOrder = "AKX",
    /**
    * Prior policy number
    */
    PriorPolicyNumber = "AKY",
    /**
    * Policy number
    */
    PolicyNumber = "AKZ",
    /**
    * Procurement budget number
    */
    ProcurementBudgetNumber = "ALA",
    /**
    * Domestic inventory management code
    */
    DomesticInventoryManagementCode = "ALB",
    /**
    * Customer reference number assigned to previous balance of
    */
    CustomerReferenceNumberAssignedToPreviousBalance = "ALC",
    /**
    * Previous credit advice reference number
    */
    PreviousCreditAdviceReferenceNumber = "ALD",
    /**
    * Reporting form number
    */
    ReportingFormNumber = "ALE",
    /**
    * Authorization number for exception to dangerous goods
    */
    AuthorizationNumberForExceptionToDangerousGoods = "ALF",
    /**
    * Dangerous goods security number
    */
    DangerousGoodsSecurityNumber = "ALG",
    /**
    * Dangerous goods transport licence number
    */
    DangerousGoodsTransportLicenceNumber = "ALH",
    /**
    * Previous rental agreement number
    */
    PreviousRentalAgreementNumber = "ALI",
    /**
    * Next rental agreement reason number
    */
    NextRentalAgreementReasonNumber = "ALJ",
    /**
    * Consignee's invoice number
    */
    ConsigneesInvoiceNumber = "ALK",
    /**
    * Message batch number
    */
    MessageBatchNumber = "ALL",
    /**
    * Previous delivery schedule number
    */
    PreviousDeliveryScheduleNumber = "ALM",
    /**
    * Physical inventory recount reference number
    */
    PhysicalInventoryRecountReferenceNumber = "ALN",
    /**
    * Receiving advice number
    */
    ReceivingAdviceNumber = "ALO",
    /**
    * Returnable container reference number
    */
    ReturnableContainerReferenceNumber = "ALP",
    /**
    * Returns notice number
    */
    ReturnsNoticeNumber = "ALQ",
    /**
    * Sales forecast number
    */
    SalesForecastNumber = "ALR",
    /**
    * Sales report number
    */
    SalesReportNumber = "ALS",
    /**
    * Previous tax control number
    */
    PreviousTaxControlNumber = "ALT",
    /**
    * AGERD (Aerospace Ground Equipment Requirement Data) number
    */
    AgerdAerospaceGroundEquipmentRequirementDataNumber = "ALU",
    /**
    * Registered capital reference
    */
    RegisteredCapitalReference = "ALV",
    /**
    * Standard number of inspection document
    */
    StandardNumberInspectionDocument = "ALW",
    /**
    * Model
    */
    Model = "ALX",
    /**
    * Financial management reference
    */
    FinancialManagementReference = "ALY",
    /**
    * NOTIfication for COLlection number (NOTICOL)
    */
    NotificationForCollectionNumberNoticol = "ALZ",
    /**
    * Previous request for metered reading reference number
    */
    PreviousRequestForMeteredReadingReferenceNumber = "AMA",
    /**
    * Next rental agreement number
    */
    NextRentalAgreementNumber = "AMB",
    /**
    * Reference number of a request for metered reading
    */
    ReferenceNumberARequestForMeteredReading = "AMC",
    /**
    * Hastening number
    */
    HasteningNumber = "AMD",
    /**
    * Repair data request number
    */
    RepairDataRequestNumber = "AME",
    /**
    * Consumption data request number
    */
    ConsumptionDataRequestNumber = "AMF",
    /**
    * Profile number
    */
    ProfileNumber = "AMG",
    /**
    * Case number
    */
    CaseNumber = "AMH",
    /**
    * Government quality assurance and control level Number
    */
    GovernmentQualityAssuranceAndControlLevelNumber = "AMI",
    /**
    * Payment plan reference
    */
    PaymentPlanReference = "AMJ",
    /**
    * Replaced meter unit number
    */
    ReplacedMeterUnitNumber = "AMK",
    /**
    * Replenishment purchase order range end number
    */
    ReplenishmentPurchaseOrderRangeEndNumber = "AML",
    /**
    * Insurer assigned reference number
    */
    InsurerAssignedReferenceNumber = "AMM",
    /**
    * Canadian excise entry number
    */
    CanadianExciseEntryNumber = "AMN",
    /**
    * Premium rate table
    */
    PremiumRateTable = "AMO",
    /**
    * Advise through bank's reference
    */
    AdviseThroughBanksReference = "AMP",
    /**
    * US, Department of Transportation bond surety code
    */
    UsDepartmentTransportationBondSuretyCode = "AMQ",
    /**
    * US, Food and Drug Administration establishment indicator
    */
    UsFoodAndDrugAdministrationEstablishmentIndicator = "AMR",
    /**
    * US, Federal Communications Commission (FCC) import
    */
    UsFederalCommunicationsCommissionFccImport = "AMS",
    /**
    * Goods and Services Tax identification number
    */
    GoodsAndServicesTaxIdentificationNumber = "AMT",
    /**
    * Integrated logistic support cross reference number
    */
    IntegratedLogisticSupportCrossReferenceNumber = "AMU",
    /**
    * Department number
    */
    DepartmentNumber = "AMV",
    /**
    * Buyer's catalogue number
    */
    BuyersCatalogueNumber = "AMW",
    /**
    * Financial settlement party's reference number
    */
    FinancialSettlementPartysReferenceNumber = "AMX",
    /**
    * Standard's version number
    */
    StandardsVersionNumber = "AMY",
    /**
    * Pipeline number
    */
    PipelineNumber = "AMZ",
    /**
    * Account servicing bank's reference number
    */
    AccountServicingBanksReferenceNumber = "ANA",
    /**
    * Completed units payment request reference
    */
    CompletedUnitsPaymentRequestReference = "ANB",
    /**
    * Payment in advance request reference
    */
    PaymentInAdvanceRequestReference = "ANC",
    /**
    * Parent file
    */
    ParentFile = "AND",
    /**
    * Sub file
    */
    SubFile = "ANE",
    /**
    * CAD file layer convention
    */
    CadFileLayerConvention = "ANF",
    /**
    * Technical regulation
    */
    TechnicalRegulation = "ANG",
    /**
    * Plot file
    */
    PlotFile = "ANH",
    /**
    * File conversion journal
    */
    FileConversionJournal = "ANI",
    /**
    * Authorization number
    */
    AuthorizationNumber = "ANJ",
    /**
    * Reference number assigned by third party
    */
    ReferenceNumberAssignedByThirdParty = "ANK",
    /**
    * Deposit reference number
    */
    DepositReferenceNumber = "ANL",
    /**
    * Named bank's reference
    */
    NamedBanksReference = "ANM",
    /**
    * Drawee's reference
    */
    DraweesReference = "ANN",
    /**
    * Case of need party's reference
    */
    CaseNeedPartysReference = "ANO",
    /**
    * Collecting bank's reference
    */
    CollectingBanksReference = "ANP",
    /**
    * Remitting bank's reference
    */
    RemittingBanksReference = "ANQ",
    /**
    * Principal's bank reference
    */
    PrincipalsBankReference = "ANR",
    /**
    * Presenting bank's reference
    */
    PresentingBanksReference = "ANS",
    /**
    * Consignee's reference
    */
    ConsigneesReference = "ANT",
    /**
    * Financial transaction reference number
    */
    FinancialTransactionReferenceNumber = "ANU",
    /**
    * Credit reference number
    */
    CreditReferenceNumber = "ANV",
    /**
    * Receiving bank's authorization number
    */
    ReceivingBanksAuthorizationNumber = "ANW",
    /**
    * Clearing reference
    */
    ClearingReference = "ANX",
    /**
    * Sending bank's reference number
    */
    SendingBanksReferenceNumber = "ANY",
    /**
    * Documentary payment reference
    */
    DocumentaryPaymentReference = "AOA",
    /**
    * Accounting file reference
    */
    AccountingFileReference = "AOD",
    /**
    * Sender's file reference number
    */
    SendersFileReferenceNumber = "AOE",
    /**
    * Receiver's file reference number
    */
    ReceiversFileReferenceNumber = "AOF",
    /**
    * Source document internal reference
    */
    SourceDocumentInternalReference = "AOG",
    /**
    * Principal's reference
    */
    PrincipalsReference = "AOH",
    /**
    * Debit reference number
    */
    DebitReferenceNumber = "AOI",
    /**
    * Calendar
    */
    Calendar = "AOJ",
    /**
    * Work shift
    */
    WorkShift = "AOK",
    /**
    * Work breakdown structure
    */
    WorkBreakdownStructure = "AOL",
    /**
    * Organisation breakdown structure
    */
    OrganisationBreakdownStructure = "AOM",
    /**
    * Work task charge number
    */
    WorkTaskChargeNumber = "AON",
    /**
    * Functional work group
    */
    FunctionalWorkGroup = "AOO",
    /**
    * Work team
    */
    WorkTeam = "AOP",
    /**
    * Department
    */
    Department = "AOQ",
    /**
    * Statement of work
    */
    StatementWork = "AOR",
    /**
    * Work package
    */
    WorkPackage = "AOS",
    /**
    * Planning package
    */
    PlanningPackage = "AOT",
    /**
    * Cost account
    */
    CostAccount = "AOU",
    /**
    * Work order
    */
    WorkOrder = "AOV",
    /**
    * Transportation Control Number (TCN)
    */
    TransportationControlNumberTcn = "AOW",
    /**
    * Constraint notation
    */
    ConstraintNotation = "AOX",
    /**
    * ETERMS reference
    */
    EtermsReference = "AOY",
    /**
    * Implementation version number
    */
    ImplementationVersionNumber = "AOZ",
    /**
    *  Accounts receivable number
    */
    AccountsReceivableNumber = "AP",
    /**
    * Incorporated legal reference
    */
    IncorporatedLegalReference = "APA",
    /**
    * Payment instalment reference number
    */
    PaymentInstalmentReferenceNumber = "APB",
    /**
    * Equipment owner reference number
    */
    EquipmentOwnerReferenceNumber = "APC",
    /**
    * Cedent's claim number
    */
    CedentsClaimNumber = "APD",
    /**
    * Reinsurer's claim number
    */
    ReinsurersClaimNumber = "APE",
    /**
    * Price/sales catalogue response reference number
    */
    PriceSalesCatalogueResponseReferenceNumber = "APF",
    /**
    * General purpose message reference number
    */
    GeneralPurposeMessageReferenceNumber = "APG",
    /**
    * Invoicing data sheet reference number
    */
    InvoicingDataSheetReferenceNumber = "APH",
    /**
    * Inventory report reference number
    */
    InventoryReportReferenceNumber = "API",
    /**
    * Ceiling formula reference number
    */
    CeilingFormulaReferenceNumber = "APJ",
    /**
    * Price variation formula reference number
    */
    PriceVariationFormulaReferenceNumber = "APK",
    /**
    * Reference to account servicing bank's message
    */
    ReferenceToAccountServicingBanksMessage = "APL",
    /**
    * Party sequence number
    */
    PartySequenceNumber = "APM",
    /**
    * Purchaser's request reference
    */
    PurchasersRequestReference = "APN",
    /**
    * Contractor request reference
    */
    ContractorRequestReference = "APO",
    /**
    * Accident reference number
    */
    AccidentReferenceNumber = "APP",
    /**
    * Commercial account summary reference number
    */
    CommercialAccountSummaryReferenceNumber = "APQ",
    /**
    * Contract breakdown reference
    */
    ContractBreakdownReference = "APR",
    /**
    * Contractor registration number
    */
    ContractorRegistrationNumber = "APS",
    /**
    * Applicable coefficient identification number
    */
    ApplicableCoefficientIdentificationNumber = "APT",
    /**
    * Special budget account number
    */
    SpecialBudgetAccountNumber = "APU",
    /**
    * Authorisation for repair reference
    */
    AuthorisationForRepairReference = "APV",
    /**
    * Manufacturer defined repair rates reference
    */
    ManufacturerDefinedRepairRatesReference = "APW",
    /**
    * Original submitter log number
    */
    OriginalSubmitterLogNumber = "APX",
    /**
    * Original submitter, parent Data Maintenance Request (DMR)
    */
    OriginalSubmitterParentDataMaintenanceRequestDmr = "APY",
    /**
    * Original submitter, child Data Maintenance Request (DMR)
    */
    OriginalSubmitterChildDataMaintenanceRequestDmr = "APZ",
    /**
    * Entry point assessment log number
    */
    EntryPointAssessmentLogNumber = "AQA",
    /**
    * Entry point assessment log number, parent DMR
    */
    EntryPointAssessmentLogNumberParentDmr = "AQB",
    /**
    * Entry point assessment log number, child DMR
    */
    EntryPointAssessmentLogNumberChildDmr = "AQC",
    /**
    * Data structure tag
    */
    DataStructureTag = "AQD",
    /**
    * Central secretariat log number
    */
    CentralSecretariatLogNumber = "AQE",
    /**
    * Central secretariat log number, parent Data Maintenance
    */
    CentralSecretariatLogNumberParentDataMaintenance = "AQF",
    /**
    * Central secretariat log number, child Data Maintenance
    */
    CentralSecretariatLogNumberChildDataMaintenance = "AQG",
    /**
    * International assessment log number
    */
    InternationalAssessmentLogNumber = "AQH",
    /**
    * International assessment log number, parent Data
    */
    InternationalAssessmentLogNumberParentData = "AQI",
    /**
    * International assessment log number, child Data Maintenance
    */
    InternationalAssessmentLogNumberChildDataMaintenance = "AQJ",
    /**
    * Status report number
    */
    StatusReportNumber = "AQK",
    /**
    * Message design group number
    */
    MessageDesignGroupNumber = "AQL",
    /**
    * US Customs Service (USCS) entry code
    */
    UsCustomsServiceUscsEntryCode = "AQM",
    /**
    * Beginning job sequence number
    */
    BeginningJobSequenceNumber = "AQN",
    /**
    * Sender's clause number
    */
    SendersClauseNumber = "AQO",
    /**
    * Dun and Bradstreet Canada's 8 digit Standard Industrial
    */
    DunAndBradstreetCanadas8DigitStandardIndustrial = "AQP",
    /**
    * Activite Principale Exercee (APE) identifier
    */
    ActivitePrincipaleExerceeApeIdentifier = "AQQ",
    /**
    * Dun and Bradstreet US 8 digit Standard Industrial
    */
    DunAndBradstreetUs8DigitStandardIndustrial = "AQR",
    /**
    * Nomenclature Activity Classification Economy (NACE)
    */
    NomenclatureActivityClassificationEconomyNace = "AQS",
    /**
    * Norme Activite Francaise (NAF) identifier
    */
    NormeActiviteFrancaiseNafIdentifier = "AQT",
    /**
    * Registered contractor activity type
    */
    RegisteredContractorActivityType = "AQU",
    /**
    * Statistic Bundes Amt (SBA) identifier
    */
    StatisticBundesAmtSbaIdentifier = "AQV",
    /**
    * State or province assigned entity identification
    */
    StateOrProvinceAssignedEntityIdentification = "AQW",
    /**
    * Institute of Security and Future Market Development (ISFMD)
    */
    InstituteSecurityAndFutureMarketDevelopmentIsfmd = "AQX",
    /**
    * File identification number
    */
    FileIdentificationNumber = "AQY",
    /**
    * Bankruptcy procedure number
    */
    BankruptcyProcedureNumber = "AQZ",
    /**
    * National government business identification number
    */
    NationalGovernmentBusinessIdentificationNumber = "ARA",
    /**
    * Prior Data Universal Number System (DUNS) number
    */
    PriorDataUniversalNumberSystemDunsNumber = "ARB",
    /**
    * Companies Registry Office (CRO) number
    */
    CompaniesRegistryOfficeCroNumber = "ARC",
    /**
    * Costa Rican judicial number
    */
    CostaRicanJudicialNumber = "ARD",
    /**
    * Numero de Identificacion Tributaria (NIT)
    */
    NumeroDeIdentificacionTributariaNit = "ARE",
    /**
    * Patron number
    */
    PatronNumber = "ARF",
    /**
    * Registro Informacion Fiscal (RIF) number
    */
    RegistroInformacionFiscalRifNumber = "ARG",
    /**
    * Registro Unico de Contribuyente (RUC) number
    */
    RegistroUnicoDeContribuyenteRucNumber = "ARH",
    /**
    * Tokyo SHOKO Research (TSR) business identifier
    */
    TokyoShokoResearchTsrBusinessIdentifier = "ARI",
    /**
    * Personal identity card number
    */
    PersonalIdentityCardNumber = "ARJ",
    /**
    * Systeme Informatique pour le Repertoire des ENtreprises
    */
    SystemeInformatiquePourLeRepertoireDesEntreprises = "ARK",
    /**
    * Systeme Informatique pour le Repertoire des ETablissements
    */
    SystemeInformatiquePourLeRepertoireDesEtablissements = "ARL",
    /**
    * Publication issue number
    */
    PublicationIssueNumber = "ARM",
    /**
    * Original filing number
    */
    OriginalFilingNumber = "ARN",
    /**
    * Document page identifier
    */
    DocumentPageIdentifier = "ARO",
    /**
    * Public filing registration number
    */
    PublicFilingRegistrationNumber = "ARP",
    /**
    * Regiristo Federal de Contribuyentes
    */
    RegiristoFederalDeContribuyentes = "ARQ",
    /**
    * Social security number
    */
    SocialSecurityNumber = "ARR",
    /**
    * Document volume number
    */
    DocumentVolumeNumber = "ARS",
    /**
    * Book number
    */
    BookNumber = "ART",
    /**
    * Stock exchange company identifier
    */
    StockExchangeCompanyIdentifier = "ARU",
    /**
    * Imputation account
    */
    ImputationAccount = "ARV",
    /**
    * Financial phase reference
    */
    FinancialPhaseReference = "ARW",
    /**
    * Technical phase reference
    */
    TechnicalPhaseReference = "ARX",
    /**
    * Prior contractor registration number
    */
    PriorContractorRegistrationNumber = "ARY",
    /**
    * Stock adjustment number
    */
    StockAdjustmentNumber = "ARZ",
    /**
    * Dispensation reference
    */
    DispensationReference = "ASA",
    /**
    * Investment reference number
    */
    InvestmentReferenceNumber = "ASB",
    /**
    * Assuming company
    */
    AssumingCompany = "ASC",
    /**
    * Budget chapter
    */
    BudgetChapter = "ASD",
    /**
    * Duty free products security number
    */
    DutyFreeProductsSecurityNumber = "ASE",
    /**
    * Duty free products receipt authorisation number
    */
    DutyFreeProductsReceiptAuthorisationNumber = "ASF",
    /**
    * Party information message reference
    */
    PartyInformationMessageReference = "ASG",
    /**
    * Formal statement reference
    */
    FormalStatementReference = "ASH",
    /**
    * Proof of delivery reference number
    */
    ProofDeliveryReferenceNumber = "ASI",
    /**
    * Supplier's credit claim reference number
    */
    SuppliersCreditClaimReferenceNumber = "ASJ",
    /**
    * Picture of actual product
    */
    PictureActualProduct = "ASK",
    /**
    * Picture of a generic product
    */
    PictureAGenericProduct = "ASL",
    /**
    * Trading partner identification number
    */
    TradingPartnerIdentificationNumber = "ASM",
    /**
    * Prior trading partner identification number
    */
    PriorTradingPartnerIdentificationNumber = "ASN",
    /**
    * Password
    */
    Password = "ASO",
    /**
    * Formal report number
    */
    FormalReportNumber = "ASP",
    /**
    * Fund account number
    */
    FundAccountNumber = "ASQ",
    /**
    * Safe custody number
    */
    SafeCustodyNumber = "ASR",
    /**
    * Master account number
    */
    MasterAccountNumber = "ASS",
    /**
    * Group reference number
    */
    GroupReferenceNumber = "AST",
    /**
    * Accounting transmission number
    */
    AccountingTransmissionNumber = "ASU",
    /**
    * Product data file number
    */
    ProductDataFileNumber = "ASV",
    /**
    * Cadastro Geral do Contribuinte (CGC)
    */
    CadastroGeralDoContribuinteCgc = "ASW",
    /**
    * Foreign resident identification number
    */
    ForeignResidentIdentificationNumber = "ASX",
    /**
    * CD-ROM
    */
    CdRom = "ASY",
    /**
    * Physical medium
    */
    PhysicalMedium = "ASZ",
    /**
    * Financial cancellation reference number
    */
    FinancialCancellationReferenceNumber = "ATA",
    /**
    * Purchase for export Customs agreement number
    */
    PurchaseForExportCustomsAgreementNumber = "ATB",
    /**
    * Judgment number
    */
    JudgmentNumber = "ATC",
    /**
    * Secretariat number
    */
    SecretariatNumber = "ATD",
    /**
    * Previous banking status message reference
    */
    PreviousBankingStatusMessageReference = "ATE",
    /**
    * Last received banking status message reference
    */
    LastReceivedBankingStatusMessageReference = "ATF",
    /**
    * Bank's documentary procedure reference
    */
    BanksDocumentaryProcedureReference = "ATG",
    /**
    * Customer's documentary procedure reference
    */
    CustomersDocumentaryProcedureReference = "ATH",
    /**
    * Safe deposit box number
    */
    SafeDepositBoxNumber = "ATI",
    /**
    * Receiving Bankgiro number
    */
    ReceivingBankgiroNumber = "ATJ",
    /**
    * Sending Bankgiro number
    */
    SendingBankgiroNumber = "ATK",
    /**
    * Bankgiro reference
    */
    BankgiroReference = "ATL",
    /**
    * Guarantee number
    */
    GuaranteeNumber = "ATM",
    /**
    * Collection instrument number
    */
    CollectionInstrumentNumber = "ATN",
    /**
    * Converted Postgiro number
    */
    ConvertedPostgiroNumber = "ATO",
    /**
    * Cost centre alignment number
    */
    CostCentreAlignmentNumber = "ATP",
    /**
    * Kamer Van Koophandel (KVK) number
    */
    KamerVanKoophandelKvkNumber = "ATQ",
    /**
    * Institut Belgo-Luxembourgeois de Codification (IBLC) number
    */
    InstitutBelgoLuxembourgeoisDeCodificationIblcNumber = "ATR",
    /**
    * External object reference
    */
    ExternalObjectReference = "ATS",
    /**
    * Exceptional transport authorisation number
    */
    ExceptionalTransportAuthorisationNumber = "ATT",
    /**
    * Clave Unica de Identificacion Tributaria (CUIT)
    */
    ClaveUnicaDeIdentificacionTributariaCuit = "ATU",
    /**
    * Registro Unico Tributario (RUT)
    */
    RegistroUnicoTributarioRut = "ATV",
    /**
    * Flat rack container bundle identification number
    */
    FlatRackContainerBundleIdentificationNumber = "ATW",
    /**
    * Transport equipment acceptance order reference
    */
    TransportEquipmentAcceptanceOrderReference = "ATX",
    /**
    * Transport equipment release order reference
    */
    TransportEquipmentReleaseOrderReference = "ATY",
    /**
    * Ship's stay reference number
    */
    ShipsStayReferenceNumber = "ATZ",
    /**
    *  Authorization to meet competition number
    */
    AuthorizationToMeetCompetitionNumber = "AU",
    /**
    * Place of positioning reference
    */
    PlacePositioningReference = "AUA",
    /**
    * Party reference
    */
    PartyReference = "AUB",
    /**
    * Issued prescription identification
    */
    IssuedPrescriptionIdentification = "AUC",
    /**
    * Collection reference
    */
    CollectionReference = "AUD",
    /**
    * Travel service
    */
    TravelService = "AUE",
    /**
    * Consignment stock contract
    */
    ConsignmentStockContract = "AUF",
    /**
    * Importer's letter of credit reference
    */
    ImportersLetterCreditReference = "AUG",
    /**
    * Performed prescription identification
    */
    PerformedPrescriptionIdentification = "AUH",
    /**
    * Image reference
    */
    ImageReference = "AUI",
    /**
    * Proposed purchase order reference number
    */
    ProposedPurchaseOrderReferenceNumber = "AUJ",
    /**
    * Application for financial support reference number
    */
    ApplicationForFinancialSupportReferenceNumber = "AUK",
    /**
    * Manufacturing quality agreement number
    */
    ManufacturingQualityAgreementNumber = "AUL",
    /**
    * Software editor reference
    */
    SoftwareEditorReference = "AUM",
    /**
    * Software reference
    */
    SoftwareReference = "AUN",
    /**
    * Software quality reference
    */
    SoftwareQualityReference = "AUO",
    /**
    * Consolidated orders' reference
    */
    ConsolidatedOrdersReference = "AUP",
    /**
    * Customs binding ruling number
    */
    CustomsBindingRulingNumber = "AUQ",
    /**
    * Customs non-binding ruling number
    */
    CustomsNonBindingRulingNumber = "AUR",
    /**
    * Delivery route reference
    */
    DeliveryRouteReference = "AUS",
    /**
    * Net area supplier reference
    */
    NetAreaSupplierReference = "AUT",
    /**
    * Time series reference
    */
    TimeSeriesReference = "AUU",
    /**
    * Connecting point to central grid
    */
    ConnectingPointToCentralGrid = "AUV",
    /**
    * Marketing plan identification number (MPIN)
    */
    MarketingPlanIdentificationNumberMpin = "AUW",
    /**
    * Entity reference number, previous
    */
    EntityReferenceNumberPrevious = "AUX",
    /**
    * International Standard Industrial Classification (ISIC)
    */
    InternationalStandardIndustrialClassificationIsic = "AUY",
    /**
    * Customs pre-approval ruling number
    */
    CustomsPreApprovalRulingNumber = "AUZ",
    /**
    *  Account payable number
    */
    AccountPayableNumber = "AV",
    /**
    * First financial institution's transaction reference
    */
    FirstFinancialInstitutionsTransactionReference = "AVA",
    /**
    * Product characteristics directory
    */
    ProductCharacteristicsDirectory = "AVB",
    /**
    * Supplier's customer reference number
    */
    SuppliersCustomerReferenceNumber = "AVC",
    /**
    * Inventory report request number
    */
    InventoryReportRequestNumber = "AVD",
    /**
    * Metering point
    */
    MeteringPoint = "AVE",
    /**
    * Passenger reservation number
    */
    PassengerReservationNumber = "AVF",
    /**
    * Slaughterhouse approval number
    */
    SlaughterhouseApprovalNumber = "AVG",
    /**
    * Meat cutting plant approval number
    */
    MeatCuttingPlantApprovalNumber = "AVH",
    /**
    * Customer travel service identifier
    */
    CustomerTravelServiceIdentifier = "AVI",
    /**
    * Export control classification number
    */
    ExportControlClassificationNumber = "AVJ",
    /**
    * Broker reference 3
    */
    BrokerReference3 = "AVK",
    /**
    * Consignment information
    */
    ConsignmentInformation = "AVL",
    /**
    * Goods item information
    */
    GoodsItemInformation = "AVM",
    /**
    * Dangerous Goods information
    */
    DangerousGoodsInformation = "AVN",
    /**
    * Pilotage services exemption number
    */
    PilotageServicesExemptionNumber = "AVO",
    /**
    * Person registration number
    */
    PersonRegistrationNumber = "AVP",
    /**
    * Place of packing approval number
    */
    PlacePackingApprovalNumber = "AVQ",
    /**
    * Original Mandate Reference
    */
    OriginalMandateReference = "AVR",
    /**
    * Mandate Reference
    */
    MandateReference = "AVS",
    /**
    * Reservation station indentifier
    */
    ReservationStationIndentifier = "AVT",
    /**
    * Unique goods shipment identifier
    */
    UniqueGoodsShipmentIdentifier = "AVU",
    /**
    * Framework Agreement Number
    */
    FrameworkAgreementNumber = "AVV",
    /**
    * Hash value
    */
    HashValue = "AVW",
    /**
    * Movement reference number
    */
    MovementReferenceNumber = "AVX",
    /**
    * Economic Operators Registration and Identification Number
    */
    EconomicOperatorsRegistrationAndIdentificationNumber = "AVY",
    /**
    * Local Reference Number
    */
    LocalReferenceNumber = "AVZ",
    /**
    * Rate code number
    */
    RateCodeNumber = "AWA",
    /**
    * Air waybill number
    */
    AirWaybillNumber = "AWB",
    /**
    * Documentary credit amendment number
    */
    DocumentaryCreditAmendmentNumber = "AWC",
    /**
    * Advising bank's reference
    */
    AdvisingBanksReference = "AWD",
    /**
    * Cost centre
    */
    CostCentre = "AWE",
    /**
    * Work item quantity determination
    */
    WorkItemQuantityDetermination = "AWF",
    /**
    * Internal data process number
    */
    InternalDataProcessNumber = "AWG",
    /**
    * Category of work reference
    */
    CategoryWorkReference = "AWH",
    /**
    * Policy form number
    */
    PolicyFormNumber = "AWI",
    /**
    * Net area
    */
    NetArea = "AWJ",
    /**
    * Service provider
    */
    ServiceProvider = "AWK",
    /**
    * Error position
    */
    ErrorPosition = "AWL",
    /**
    * Service category reference
    */
    ServiceCategoryReference = "AWM",
    /**
    * Connected location
    */
    ConnectedLocation = "AWN",
    /**
    * Related party
    */
    RelatedParty = "AWO",
    /**
    * Latest accounting entry record reference
    */
    LatestAccountingEntryRecordReference = "AWP",
    /**
    * Accounting entry
    */
    AccountingEntry = "AWQ",
    /**
    * Document reference, original
    */
    DocumentReferenceOriginal = "AWR",
    /**
    * Hygienic Certificate number, national
    */
    HygienicCertificateNumberNational = "AWS",
    /**
    * Administrative Reference Code
    */
    AdministrativeReferenceCode = "AWT",
    /**
    * Pick-up sheet number
    */
    PickUpSheetNumber = "AWU",
    /**
    * Phone number
    */
    PhoneNumber = "AWV",
    /**
    * Buyer's fund number
    */
    BuyersFundNumber = "AWW",
    /**
    * Company trading account number
    */
    CompanyTradingAccountNumber = "AWX",
    /**
    * Reserved goods identifier
    */
    ReservedGoodsIdentifier = "AWY",
    /**
    * Handling and movement reference number
    */
    HandlingAndMovementReferenceNumber = "AWZ",
    /**
    * Instruction to despatch reference number
    */
    InstructionToDespatchReferenceNumber = "AXA",
    /**
    * Instruction for returns number
    */
    InstructionForReturnsNumber = "AXB",
    /**
    * Metered services consumption report number
    */
    MeteredServicesConsumptionReportNumber = "AXC",
    /**
    * Order status enquiry number
    */
    OrderStatusEnquiryNumber = "AXD",
    /**
    * Firm booking reference number
    */
    FirmBookingReferenceNumber = "AXE",
    /**
    * Product inquiry number
    */
    ProductInquiryNumber = "AXF",
    /**
    * Split delivery number
    */
    SplitDeliveryNumber = "AXG",
    /**
    * Service relation number
    */
    ServiceRelationNumber = "AXH",
    /**
    * Serial shipping container code
    */
    SerialShippingContainerCode = "AXI",
    /**
    * Test specification number
    */
    TestSpecificationNumber = "AXJ",
    /**
    * Transport status report number
    */
    TransportStatusReportNumber = "AXK",
    /**
    * Tooling contract number
    */
    ToolingContractNumber = "AXL",
    /**
    * Formula reference number
    */
    FormulaReferenceNumber = "AXM",
    /**
    * Pre-agreement number
    */
    PreAgreementNumber = "AXN",
    /**
    * Product certification number
    */
    ProductCertificationNumber = "AXO",
    /**
    * Consignment contract number
    */
    ConsignmentContractNumber = "AXP",
    /**
    * Product specification reference number
    */
    ProductSpecificationReferenceNumber = "AXQ",
    /**
    * Payroll deduction advice reference
    */
    PayrollDeductionAdviceReference = "AXR",
    /**
    * TRACES party identification
    */
    TracesPartyIdentification = "AXS",
    /**
    *  Beginning meter reading actual
    */
    BeginningMeterReadingActual = "BA",
    /**
    *  Buyer's contract number
    */
    BuyersContractNumber = "BC",
    /**
    *  Bid number
    */
    BidNumber = "BD",
    /**
    *  Beginning meter reading estimated
    */
    BeginningMeterReadingEstimated = "BE",
    /**
    *  House bill of lading number
    */
    HouseBillLadingNumber = "BH",
    /**
    *  Bill of lading number
    */
    BillLadingNumber = "BM",
    /**
    *  Consignment identifier, carrier assigned
    */
    ConsignmentIdentifierCarrierAssigned = "BN",
    /**
    *  Blanket order number
    */
    BlanketOrderNumber = "BO",
    /**
    *  Broker or sales office number
    */
    BrokerOrSalesOfficeNumber = "BR",
    /**
    *  Batch number/lot number
    */
    BatchNumberLotNumber = "BT",
    /**
    * Battery and accumulator producer registration number
    */
    BatteryAndAccumulatorProducerRegistrationNumber = "BTP",
    /**
    *  Blended with number
    */
    BlendedWithNumber = "BW",
    /**
    * IATA Cargo Agent CASS Address number
    */
    IataCargoAgentCassAddressNumber = "CAS",
    /**
    * Matching of entries, balanced
    */
    MatchingEntriesBalanced = "CAT",
    /**
    * Entry flagging
    */
    EntryFlagging = "CAU",
    /**
    * Matching of entries, unbalanced
    */
    MatchingEntriesUnbalanced = "CAV",
    /**
    * Document reference, internal
    */
    DocumentReferenceInternal = "CAW",
    /**
    * European Value Added Tax identification
    */
    EuropeanValueAddedTaxIdentification = "CAX",
    /**
    * Cost accounting document
    */
    CostAccountingDocument = "CAY",
    /**
    * Grid operator's customer reference number
    */
    GridOperatorsCustomerReferenceNumber = "CAZ",
    /**
    * Ticket control number
    */
    TicketControlNumber = "CBA",
    /**
    * Order shipment grouping reference
    */
    OrderShipmentGroupingReference = "CBB",
    /**
    *  Credit note number
    */
    CreditNoteNumber = "CD",
    /**
    * Ceding company
    */
    CedingCompany = "CEC",
    /**
    * Debit letter number
    */
    DebitLetterNumber = "CED",
    /**
    * Consignee's further order
    */
    ConsigneesFurtherOrder = "CFE",
    /**
    * Animal farm licence number
    */
    AnimalFarmLicenceNumber = "CFF",
    /**
    * Consignor's further order
    */
    ConsignorsFurtherOrder = "CFO",
    /**
    *  Consignee's order number
    */
    ConsigneesOrderNumber = "CG",
    /**
    *  Customer catalogue number
    */
    CustomerCatalogueNumber = "CH",
    /**
    *  Cheque number
    */
    ChequeNumber = "CK",
    /**
    * Checking number
    */
    CheckingNumber = "CKN",
    /**
    *  Credit memo number
    */
    CreditMemoNumber = "CM",
    /**
    * Road consignment note number
    */
    RoadConsignmentNoteNumber = "CMR",
    /**
    *  Carrier's reference number
    */
    CarriersReferenceNumber = "CN",
    /**
    * Charges note document attachment indicator
    */
    ChargesNoteDocumentAttachmentIndicator = "CNO",
    /**
    * Call off order number
    */
    CallOffOrderNumber = "COF",
    /**
    *  Condition of purchase document number
    */
    ConditionPurchaseDocumentNumber = "CP",
    /**
    *  Customer reference number
    */
    CustomerReferenceNumber = "CR",
    /**
    * Transport means journey identifier
    */
    TransportMeansJourneyIdentifier = "CRN",
    /**
    *  Condition of sale document number
    */
    ConditionSaleDocumentNumber = "CS",
    /**
    * Team assignment number
    */
    TeamAssignmentNumber = "CST",
    /**
    *  Contract number
    */
    ContractNumber = "CT",
    /**
    *  Consignment identifier, consignor assigned
    */
    ConsignmentIdentifierConsignorAssigned = "CU",
    /**
    *  Container operators reference number
    */
    ContainerOperatorsReferenceNumber = "CV",
    /**
    *  Package number
    */
    PackageNumber = "CW",
    /**
    *  Cooperation contract number
    */
    CooperationContractNumber = "CZ",
    /**
    *  Deferment approval number
    */
    DefermentApprovalNumber = "DA",
    /**
    * Debit account number
    */
    DebitAccountNumber = "DAN",
    /**
    *  Buyer's debtor number
    */
    BuyersDebtorNumber = "DB",
    /**
    *  Distributor invoice number
    */
    DistributorInvoiceNumber = "DI",
    /**
    *  Debit note number
    */
    DebitNoteNumber = "DL",
    /**
    *  Document identifier
    */
    DocumentIdentifier = "DM",
    /**
    *  Delivery note number
    */
    DeliveryNoteNumber = "DQ",
    /**
    *  Dock receipt number
    */
    DockReceiptNumber = "DR",
    /**
    *  Ending meter reading actual
    */
    EndingMeterReadingActual = "EA",
    /**
    *  Embargo permit number
    */
    EmbargoPermitNumber = "EB",
    /**
    *  Export declaration
    */
    ExportDeclaration = "ED",
    /**
    *  Ending meter reading estimated
    */
    EndingMeterReadingEstimated = "EE",
    /**
    * Electrical and electronic equipment producer registration
    */
    ElectricalAndElectronicEquipmentProducerRegistration = "EEP",
    /**
    *  Employer's identification number
    */
    EmployersIdentificationNumber = "EI",
    /**
    *  Embargo number
    */
    EmbargoNumber = "EN",
    /**
    *  Equipment number
    */
    EquipmentNumber = "EQ",
    /**
    *  Container/equipment receipt number
    */
    ContainerEquipmentReceiptNumber = "ER",
    /**
    * Exporter's reference number
    */
    ExportersReferenceNumber = "ERN",
    /**
    *  Excess transportation number
    */
    ExcessTransportationNumber = "ET",
    /**
    *  Export permit identifier
    */
    ExportPermitIdentifier = "EX",
    /**
    *  Fiscal number
    */
    FiscalNumber = "FC",
    /**
    *  Consignment identifier, freight forwarder assigned
    */
    ConsignmentIdentifierFreightForwarderAssigned = "FF",
    /**
    *  File line identifier
    */
    FileLineIdentifier = "FI",
    /**
    * Flow reference number
    */
    FlowReferenceNumber = "FLW",
    /**
    *  Freight bill number
    */
    FreightBillNumber = "FN",
    /**
    *  Foreign exchange
    */
    ForeignExchange = "FO",
    /**
    *  Final sequence number
    */
    FinalSequenceNumber = "FS",
    /**
    *  Free zone identifier
    */
    FreeZoneIdentifier = "FT",
    /**
    *  File version number
    */
    FileVersionNumber = "FV",
    /**
    *  Foreign exchange contract number
    */
    ForeignExchangeContractNumber = "FX",
    /**
    *  Standard's number
    */
    StandardsNumber = "GA",
    /**
    *  Government contract number
    */
    GovernmentContractNumber = "GC",
    /**
    *  Standard's code number
    */
    StandardsCodeNumber = "GD",
    /**
    * General declaration number
    */
    GeneralDeclarationNumber = "GDN",
    /**
    *  Government reference number
    */
    GovernmentReferenceNumber = "GN",
    /**
    *  Harmonised system number
    */
    HarmonisedSystemNumber = "HS",
    /**
    * House waybill number
    */
    HouseWaybillNumber = "HWB",
    /**
    *  Internal vendor number
    */
    InternalVendorNumber = "IA",
    /**
    *  In bond number
    */
    InBondNumber = "IB",
    /**
    * IATA cargo agent code number
    */
    IataCargoAgentCodeNumber = "ICA",
    /**
    * Insurance certificate reference number
    */
    InsuranceCertificateReferenceNumber = "ICE",
    /**
    * Insurance contract reference number
    */
    InsuranceContractReferenceNumber = "ICO",
    /**
    *  Initial sample inspection report number
    */
    InitialSampleInspectionReportNumber = "II",
    /**
    *  Internal order number
    */
    InternalOrderNumber = "IL",
    /**
    * Intermediary broker
    */
    IntermediaryBroker = "INB",
    /**
    * Interchange number new
    */
    InterchangeNumberNew = "INN",
    /**
    * Interchange number old
    */
    InterchangeNumberOld = "INO",
    /**
    *  Import permit identifier
    */
    ImportPermitIdentifier = "IP",
    /**
    *  Invoice number suffix
    */
    InvoiceNumberSuffix = "IS",
    /**
    *  Internal customer number
    */
    InternalCustomerNumber = "IT",
    /**
    *  Invoice document identifier
    */
    InvoiceDocumentIdentifier = "IV",
    /**
    *  Job number
    */
    JobNumber = "JB",
    /**
    *  Ending job sequence number
    */
    EndingJobSequenceNumber = "JE",
    /**
    *  Shipping label serial number
    */
    ShippingLabelSerialNumber = "LA",
    /**
    * Loading authorisation identifier
    */
    LoadingAuthorisationIdentifier = "LAN",
    /**
    * Lower number in range
    */
    LowerNumberInRange = "LAR",
    /**
    *  Lockbox
    */
    Lockbox = "LB",
    /**
    *  Letter of credit number
    */
    LetterCreditNumber = "LC",
    /**
    *  Document line identifier
    */
    DocumentLineIdentifier = "LI",
    /**
    *  Load planning number
    */
    LoadPlanningNumber = "LO",
    /**
    * Reservation office identifier
    */
    ReservationOfficeIdentifier = "LRC",
    /**
    *  Bar coded label serial number
    */
    BarCodedLabelSerialNumber = "LS",
    /**
    *  Ship notice/manifest number
    */
    ShipNoticeManifestNumber = "MA",
    /**
    *  Master bill of lading number
    */
    MasterBillLadingNumber = "MB",
    /**
    *  Manufacturer's part number
    */
    ManufacturersPartNumber = "MF",
    /**
    *  Meter unit number
    */
    MeterUnitNumber = "MG",
    /**
    *  Manufacturing order number
    */
    ManufacturingOrderNumber = "MH",
    /**
    *  Message recipient
    */
    MessageRecipient = "MR",
    /**
    * Mailing reference number
    */
    MailingReferenceNumber = "MRN",
    /**
    *  Message sender
    */
    MessageSender = "MS",
    /**
    * Manufacturer's material safety data sheet number
    */
    ManufacturersMaterialSafetyDataSheetNumber = "MSS",
    /**
    * Master air waybill number
    */
    MasterAirWaybillNumber = "MWB",
    /**
    *  North American hazardous goods classification number
    */
    NorthAmericanHazardousGoodsClassificationNumber = "nan",
    /**
    *  Nota Fiscal
    */
    NotaFiscal = "NF",
    /**
    *  Current invoice number
    */
    CurrentInvoiceNumber = "OH",
    /**
    *  Previous invoice number
    */
    PreviousInvoiceNumber = "OI",
    /**
    *  Order document identifier, buyer assigned
    */
    OrderDocumentIdentifierBuyerAssigned = "ON",
    /**
    *  Original purchase order
    */
    OriginalPurchaseOrder = "OP",
    /**
    *  General order number
    */
    GeneralOrderNumber = "OR",
    /**
    *  Payer's financial institution account number
    */
    PayersFinancialInstitutionAccountNumber = "PB",
    /**
    *  Production code
    */
    ProductionCode = "PC",
    /**
    *  Promotion deal number
    */
    PromotionDealNumber = "PD",
    /**
    *  Plant number
    */
    PlantNumber = "PE",
    /**
    *  Prime contractor contract number
    */
    PrimeContractorContractNumber = "PF",
    /**
    *  Price list version number
    */
    PriceListVersionNumber = "PI",
    /**
    *  Packing list number
    */
    PackingListNumber = "PK",
    /**
    *  Price list number
    */
    PriceListNumber = "PL",
    /**
    * Purchase order response number
    */
    PurchaseOrderResponseNumber = "POR",
    /**
    *  Purchase order change number
    */
    PurchaseOrderChangeNumber = "PP",
    /**
    *  Payment reference
    */
    PaymentReference = "PQ",
    /**
    *  Price quote number
    */
    PriceQuoteNumber = "PR",
    /**
    *  Purchase order number suffix
    */
    PurchaseOrderNumberSuffix = "PS",
    /**
    *  Prior purchase order number
    */
    PriorPurchaseOrderNumber = "PW",
    /**
    *  Payee's financial institution account number
    */
    PayeesFinancialInstitutionAccountNumber = "PY",
    /**
    *  Remittance advice number
    */
    RemittanceAdviceNumber = "RA",
    /**
    *  Rail/road routing code
    */
    RailRoadRoutingCode = "RC",
    /**
    * Railway consignment note number
    */
    RailwayConsignmentNoteNumber = "RCN",
    /**
    *  Release number
    */
    ReleaseNumber = "RE",
    /**
    * Consignment receipt identifier
    */
    ConsignmentReceiptIdentifier = "REN",
    /**
    *  Export reference number
    */
    ExportReferenceNumber = "RF",
    /**
    *  Payer's financial institution transit routing No.(ACH
    */
    PayersFinancialInstitutionTransitRoutingNoAch = "RR",
    /**
    *  Payee's financial institution transit routing No.
    */
    PayeesFinancialInstitutionTransitRoutingNo = "RT",
    /**
    *  Sales person number
    */
    SalesPersonNumber = "SA",
    /**
    *  Sales region number
    */
    SalesRegionNumber = "SB",
    /**
    *  Sales department number
    */
    SalesDepartmentNumber = "SD",
    /**
    *  Serial number
    */
    SerialNumber = "SE",
    /**
    * Allocated seat
    */
    AllocatedSeat = "SEA",
    /**
    *  Ship from
    */
    ShipFrom = "SF",
    /**
    *  Previous highest schedule number
    */
    PreviousHighestScheduleNumber = "SH",
    /**
    *  SID (Shipper's identifying number for shipment)
    */
    SidShippersIdentifyingNumberForShipment = "SI",
    /**
    *  Sales office number
    */
    SalesOfficeNumber = "SM",
    /**
    *  Transport equipment seal identifier
    */
    TransportEquipmentSealIdentifier = "SN",
    /**
    *  Scan line
    */
    ScanLine = "SP",
    /**
    *  Equipment sequence number
    */
    EquipmentSequenceNumber = "SQ",
    /**
    * Shipment reference number
    */
    ShipmentReferenceNumber = "SRN",
    /**
    *  Sellers reference number
    */
    SellersReferenceNumber = "SS",
    /**
    * Station reference number
    */
    StationReferenceNumber = "STA",
    /**
    *  Swap order number
    */
    SwapOrderNumber = "SW",
    /**
    *  Specification number
    */
    SpecificationNumber = "SZ",
    /**
    *  Trucker's bill of lading
    */
    TruckersBillLading = "TB",
    /**
    * Terminal operator's consignment reference
    */
    TerminalOperatorsConsignmentReference = "TCR",
    /**
    *  Telex message number
    */
    TelexMessageNumber = "TE",
    /**
    *  Transfer number
    */
    TransferNumber = "TF",
    /**
    *  TIR carnet number
    */
    TirCarnetNumber = "TI",
    /**
    * Transport instruction number
    */
    TransportInstructionNumber = "TIN",
    /**
    *  Tax exemption licence number
    */
    TaxExemptionLicenceNumber = "TL",
    /**
    *  Transaction reference number
    */
    TransactionReferenceNumber = "TN",
    /**
    *  Test report number
    */
    TestReportNumber = "TP",
    /**
    * Upper number of range
    */
    UpperNumberRange = "UAR",
    /**
    *  Ultimate customer's reference number
    */
    UltimateCustomersReferenceNumber = "UC",
    /**
    * Unique consignment reference number
    */
    UniqueConsignmentReferenceNumber = "UCN",
    /**
    *  United Nations Dangerous Goods identifier
    */
    UnitedNationsDangerousGoodsIdentifier = "UN",
    /**
    *  Ultimate customer's order number
    */
    UltimateCustomersOrderNumber = "UO",
    /**
    * Uniform Resource Identifier
    */
    UniformResourceIdentifier = "URI",
    /**
    *  VAT registration number
    */
    VatRegistrationNumber = "VA",
    /**
    *  Vendor contract number
    */
    VendorContractNumber = "VC",
    /**
    * Transport equipment gross mass verification reference
    */
    TransportEquipmentGrossMassVerificationReference = "VGR",
    /**
    *  Vessel identifier
    */
    VesselIdentifier = "VM",
    /**
    *  Order number (vendor)
    */
    OrderNumberVendor = "VN",
    /**
    * Voyage number
    */
    VoyageNumber = "VON",
    /**
    * Transport equipment gross mass verification order reference
    */
    TransportEquipmentGrossMassVerificationOrderReference = "VOR",
    /**
    *  Vendor product number
    */
    VendorProductNumber = "VP",
    /**
    *  Vendor ID number
    */
    VendorIdNumber = "VR",
    /**
    *  Vendor order number suffix
    */
    VendorOrderNumberSuffix = "VS",
    /**
    *  Motor vehicle identification number
    */
    MotorVehicleIdentificationNumber = "VT",
    /**
    *  Voucher number
    */
    VoucherNumber = "VV",
    /**
    *  Warehouse entry number
    */
    WarehouseEntryNumber = "WE",
    /**
    *  Weight agreement number
    */
    WeightAgreementNumber = "WM",
    /**
    *  Well number
    */
    WellNumber = "WN",
    /**
    *  Warehouse receipt number
    */
    WarehouseReceiptNumber = "WR",
    /**
    *  Warehouse storage location number
    */
    WarehouseStorageLocationNumber = "WS",
    /**
    *  Rail waybill number
    */
    RailWaybillNumber = "WY",
    /**
    *  Company/place registration number
    */
    CompanyPlaceRegistrationNumber = "XA",
    /**
    *  Cargo control number
    */
    CargoControlNumber = "XC",
    /**
    *  Previous cargo control number
    */
    PreviousCargoControlNumber = "XP",
    /**
    * Mutually defined reference number
    */
    MutuallyDefinedReferenceNumber = "ZZZ",
}

export function description(value: Enum1153): string {
    switch (value) {
        case Enum1153.OrderAcknowledgementDocumentIdentifier: return "Order acknowledgement document identifier";
        case Enum1153.ProformaInvoiceDocumentIdentifier: return "Proforma invoice document identifier";
        case Enum1153.DocumentaryCreditIdentifier: return "Documentary credit identifier";
        case Enum1153.ContractDocumentAddendumIdentifier: return "Contract document addendum identifier";
        case Enum1153.GoodsDeclarationNumber: return "Goods declaration number";
        case Enum1153.DebitCardNumber: return "Debit card number";
        case Enum1153.OfferNumber: return "Offer number";
        case Enum1153.BanksBatchInterbankTransactionReferenceNumber: return "Bank's batch interbank transaction reference number";
        case Enum1153.BanksIndividualInterbankTransactionReferenceNumber: return "Bank's individual interbank transaction reference number";
        case Enum1153.DeliveryOrderNumber: return "Delivery order number";
        case Enum1153.DespatchAdviceNumber: return "Despatch advice number";
        case Enum1153.DrawingNumber: return "Drawing number";
        case Enum1153.WaybillNumber: return "Waybill number";
        case Enum1153.DeliveryScheduleNumber: return "Delivery schedule number";
        case Enum1153.ConsignmentIdentifierConsigneeAssigned: return "Consignment identifier, consignee assigned";
        case Enum1153.PartialShipmentIdentifier: return "Partial shipment identifier";
        case Enum1153.TransportEquipmentIdentifier: return "Transport equipment identifier";
        case Enum1153.MunicipalityAssignedBusinessRegistryNumber: return "Municipality assigned business registry number";
        case Enum1153.TransportContractDocumentIdentifier: return "Transport contract document identifier";
        case Enum1153.MasterLabelNumber: return "Master label number";
        case Enum1153.DespatchNoteDocumentIdentifier: return "Despatch note document identifier";
        case Enum1153.EnquiryNumber: return "Enquiry number";
        case Enum1153.DocketNumber: return "Docket number";
        case Enum1153.CivilActionNumber: return "Civil action number";
        case Enum1153.CarriersAgentReferenceNumber: return "Carrier's agent reference number";
        case Enum1153.StandardCarrierAlphaCodeScacNumber: return "Standard Carrier Alpha Code (SCAC) number";
        case Enum1153.CustomsValuationDecisionNumber: return "Customs valuation decision number";
        case Enum1153.EndUseAuthorizationNumber: return "End use authorization number";
        case Enum1153.AntiDumpingCaseNumber: return "Anti-dumping case number";
        case Enum1153.CustomsTariffNumber: return "Customs tariff number";
        case Enum1153.DeclarantsReferenceNumber: return "Declarant's reference number";
        case Enum1153.RepairEstimateNumber: return "Repair estimate number";
        case Enum1153.CustomsDecisionRequestNumber: return "Customs decision request number";
        case Enum1153.SubHouseBillLadingNumber: return "Sub-house bill of lading number";
        case Enum1153.TaxPaymentIdentifier: return "Tax payment identifier";
        case Enum1153.QuotaNumber: return "Quota number";
        case Enum1153.TransitOnwardCarriageGuaranteeBondNumber: return "Transit (onward carriage) guarantee (bond) number";
        case Enum1153.CustomsGuaranteeNumber: return "Customs guarantee number";
        case Enum1153.ReplacingPartNumber: return "Replacing part number";
        case Enum1153.SellersCatalogueNumber: return "Seller's catalogue number";
        case Enum1153.OriginatorsReference: return "Originator's reference";
        case Enum1153.DeclarantsCustomsIdentityNumber: return "Declarant's Customs identity number";
        case Enum1153.ImporterReferenceNumber: return "Importer reference number";
        case Enum1153.ExportClearanceInstructionReferenceNumber: return "Export clearance instruction reference number";
        case Enum1153.ImportClearanceInstructionReferenceNumber: return "Import clearance instruction reference number";
        case Enum1153.GoodsDeclarationDocumentIdentifierCustoms: return "Goods declaration document identifier, Customs";
        case Enum1153.ArticleNumber: return "Article number";
        case Enum1153.IntraPlantRouting: return "Intra-plant routing";
        case Enum1153.StockKeepingUnitNumber: return "Stock keeping unit number";
        case Enum1153.TextElementIdentifierDeletionReference: return "Text Element Identifier deletion reference";
        case Enum1153.AllotmentIdentificationAir: return "Allotment identification (Air)";
        case Enum1153.VehicleLicenceNumber: return "Vehicle licence number";
        case Enum1153.AirCargoTransferManifest: return " Air cargo transfer manifest";
        case Enum1153.CargoAcceptanceOrderReferenceNumber: return "Cargo acceptance order reference number";
        case Enum1153.UsGovernmentAgencyNumber: return "US government agency number";
        case Enum1153.ShippingUnitIdentification: return "Shipping unit identification";
        case Enum1153.AdditionalReferenceNumber: return "Additional reference number";
        case Enum1153.RelatedDocumentNumber: return "Related document number";
        case Enum1153.AddresseeReference: return "Addressee reference";
        case Enum1153.AtaCarnetNumber: return "ATA carnet number";
        case Enum1153.PackagingUnitIdentification: return "Packaging unit identification";
        case Enum1153.OuterpackagingUnitIdentification: return "Outerpackaging unit identification";
        case Enum1153.CustomerMaterialSpecificationNumber: return "Customer material specification number";
        case Enum1153.BankReference: return "Bank reference";
        case Enum1153.PrincipalReferenceNumber: return "Principal reference number";
        case Enum1153.CollectionAdviceDocumentIdentifier: return "Collection advice document identifier";
        case Enum1153.IronChargeNumber: return "Iron charge number";
        case Enum1153.HotRollNumber: return "Hot roll number";
        case Enum1153.ColdRollNumber: return "Cold roll number";
        case Enum1153.RailwayWagonNumber: return "Railway wagon number";
        case Enum1153.UniqueClaimsReferenceNumberSender: return "Unique claims reference number of the sender";
        case Enum1153.LossEventNumber: return "Loss/event number";
        case Enum1153.EstimateOrderReferenceNumber: return "Estimate order reference number";
        case Enum1153.ReferenceNumberToPreviousMessage: return "Reference number to previous message";
        case Enum1153.BankersAcceptance: return "Banker's acceptance";
        case Enum1153.DutyMemoNumber: return "Duty memo number";
        case Enum1153.EquipmentTransportChargeNumber: return "Equipment transport charge number";
        case Enum1153.BuyersItemNumber: return "Buyer's item number";
        case Enum1153.MaturedCertificateDeposit: return "Matured certificate of deposit";
        case Enum1153.Loan: return "Loan";
        case Enum1153.AnalysisNumberTestNumber: return "Analysis number/test number";
        case Enum1153.AccountNumber: return "Account number";
        case Enum1153.TreatyNumber: return "Treaty number";
        case Enum1153.CatastropheNumber: return "Catastrophe number";
        case Enum1153.BureauSigningStatementReference: return "Bureau signing (statement reference)";
        case Enum1153.CompanySyndicateReference1: return "Company / syndicate reference 1";
        case Enum1153.CompanySyndicateReference2: return "Company / syndicate reference 2";
        case Enum1153.OrderingCustomerConsignmentReferenceNumber: return "Ordering customer consignment reference number";
        case Enum1153.ShipownersAuthorizationNumber: return "Shipowner's authorization number";
        case Enum1153.InlandTransportOrderNumber: return "Inland transport order number";
        case Enum1153.ContainerWorkOrderReferenceNumber: return "Container work order reference number";
        case Enum1153.StatementNumber: return "Statement number";
        case Enum1153.UniqueMarketReference: return "Unique market reference";
        case Enum1153.GroupAccounting: return "Group accounting";
        case Enum1153.BrokerReference1: return "Broker reference 1";
        case Enum1153.BrokerReference2: return "Broker reference 2";
        case Enum1153.LloydsClaimsOfficeReference: return "Lloyd's claims office reference";
        case Enum1153.SecureDeliveryTermsAndConditionsAgreementReference: return "Secure delivery terms and conditions agreement reference";
        case Enum1153.ReportNumber: return "Report number";
        case Enum1153.TraderAccountNumber: return "Trader account number";
        case Enum1153.AuthorizationForExpenseAfeNumber: return " Authorization for expense (AFE) number";
        case Enum1153.GovernmentAgencyReferenceNumber: return "Government agency reference number";
        case Enum1153.AssemblyNumber: return "Assembly number";
        case Enum1153.SymbolNumber: return "Symbol number";
        case Enum1153.CommodityNumber: return "Commodity number";
        case Enum1153.Eur1CertificateNumber: return "Eur 1 certificate number";
        case Enum1153.CustomerProcessSpecificationNumber: return "Customer process specification number";
        case Enum1153.CustomerSpecificationNumber: return "Customer specification number";
        case Enum1153.ApplicableInstructionsOrStandards: return "Applicable instructions or standards";
        case Enum1153.RegistrationNumberPreviousCustomsDeclaration: return "Registration number of previous Customs declaration";
        case Enum1153.PostEntryReference: return "Post-entry reference";
        case Enum1153.PaymentOrderNumber: return "Payment order number";
        case Enum1153.DeliveryNumberTransport: return "Delivery number (transport)";
        case Enum1153.TransportRoute: return "Transport route";
        case Enum1153.CustomersUnitInventoryNumber: return "Customer's unit inventory number";
        case Enum1153.ProductReservationNumber: return "Product reservation number";
        case Enum1153.ProjectNumber: return "Project number";
        case Enum1153.DrawingListNumber: return "Drawing list number";
        case Enum1153.ProjectSpecificationNumber: return "Project specification number";
        case Enum1153.PrimaryReference: return "Primary reference";
        case Enum1153.RequestForCancellationNumber: return "Request for cancellation number";
        case Enum1153.SuppliersControlNumber: return "Supplier's control number";
        case Enum1153.ShippingNoteNumber: return "Shipping note number";
        case Enum1153.EmptyContainerBillNumber: return "Empty container bill number";
        case Enum1153.NonNegotiableMaritimeTransportDocumentNumber: return "Non-negotiable maritime transport document number";
        case Enum1153.SubstituteAirWaybillNumber: return "Substitute air waybill number";
        case Enum1153.DespatchNotePostParcelsNumber: return "Despatch note (post parcels) number";
        case Enum1153.AirlinesFlightIdentificationNumber: return " Airlines flight identification number";
        case Enum1153.ThroughBillLadingNumber: return "Through bill of lading number";
        case Enum1153.CargoManifestNumber: return "Cargo manifest number";
        case Enum1153.BordereauNumber: return "Bordereau number";
        case Enum1153.CustomsItemNumber: return "Customs item number";
        case Enum1153.ExportControlCommodityNumberEccn: return "Export Control Commodity number (ECCN)";
        case Enum1153.MarkingLabelReference: return "Marking/label reference";
        case Enum1153.TariffNumber: return "Tariff number";
        case Enum1153.ReplenishmentPurchaseOrderNumber: return "Replenishment purchase order number";
        case Enum1153.ImmediateTransportationNoForInBondMovement: return "Immediate transportation no. for in bond movement";
        case Enum1153.TransportationExportationNoForInBondMovement: return "Transportation exportation no. for in bond movement";
        case Enum1153.ImmediateExportationNoForInBondMovement: return "Immediate exportation no. for in bond movement";
        case Enum1153.AssociatedInvoices: return "Associated invoices";
        case Enum1153.SecondaryCustomsReference: return "Secondary Customs reference";
        case Enum1153.AccountPartysReference: return "Account party's reference";
        case Enum1153.BeneficiarysReference: return "Beneficiary's reference";
        case Enum1153.SecondBeneficiarysReference: return "Second beneficiary's reference";
        case Enum1153.ApplicantsBankReference: return "Applicant's bank reference";
        case Enum1153.IssuingBanksReference: return "Issuing bank's reference";
        case Enum1153.BeneficiarysBankReference: return "Beneficiary's bank reference";
        case Enum1153.DirectPaymentValuationNumber: return "Direct payment valuation number";
        case Enum1153.DirectPaymentValuationRequestNumber: return "Direct payment valuation request number";
        case Enum1153.QuantityValuationNumber: return "Quantity valuation number";
        case Enum1153.QuantityValuationRequestNumber: return "Quantity valuation request number";
        case Enum1153.BillQuantitiesNumber: return "Bill of quantities number";
        case Enum1153.PaymentValuationNumber: return "Payment valuation number";
        case Enum1153.SituationNumber: return "Situation number";
        case Enum1153.AgreementToPayNumber: return "Agreement to pay number";
        case Enum1153.ContractPartyReferenceNumber: return "Contract party reference number";
        case Enum1153.AccountPartysBankReference: return "Account party's bank reference";
        case Enum1153.AgentsBankReference: return "Agent's bank reference";
        case Enum1153.AgentsReference: return "Agent's reference";
        case Enum1153.ApplicantsReference: return "Applicant's reference";
        case Enum1153.DisputeNumber: return "Dispute number";
        case Enum1153.CreditRatingAgencysReferenceNumber: return "Credit rating agency's reference number";
        case Enum1153.RequestNumber: return "Request number";
        case Enum1153.SingleTransactionSequenceNumber: return "Single transaction sequence number";
        case Enum1153.ApplicationReferenceNumber: return "Application reference number";
        case Enum1153.DeliveryVerificationCertificate: return "Delivery verification certificate";
        case Enum1153.NumberTemporaryImportationDocument: return "Number of temporary importation document";
        case Enum1153.ReferenceNumberQuotedOnStatement: return "Reference number quoted on statement";
        case Enum1153.SendersReferenceToOriginalMessage: return "Sender's reference to the original message";
        case Enum1153.CompanyIssuedEquipmentId: return "Company issued equipment ID";
        case Enum1153.DomesticFlightNumber: return "Domestic flight number";
        case Enum1153.InternationalFlightNumber: return "International flight number";
        case Enum1153.EmployerIdentificationNumberServiceBureau: return "Employer identification number of service bureau";
        case Enum1153.ServiceGroupIdentificationNumber: return "Service group identification number";
        case Enum1153.MemberNumber: return "Member number";
        case Enum1153.PreviousMemberNumber: return "Previous member number";
        case Enum1153.SchemePlanNumber: return "Scheme/plan number";
        case Enum1153.PreviousSchemePlanNumber: return "Previous scheme/plan number";
        case Enum1153.ReceivingPartysMemberIdentification: return "Receiving party's member identification";
        case Enum1153.PayrollNumber: return "Payroll number";
        case Enum1153.PackagingSpecificationNumber: return "Packaging specification number";
        case Enum1153.AuthorityIssuedEquipmentIdentification: return "Authority issued equipment identification";
        case Enum1153.TrainingFlightNumber: return "Training flight number";
        case Enum1153.FundCodeNumber: return "Fund code number";
        case Enum1153.SignalCodeNumber: return "Signal code number";
        case Enum1153.MajorForceProgramNumber: return "Major force program number";
        case Enum1153.NominationNumber: return "Nomination number";
        case Enum1153.LaboratoryRegistrationNumber: return "Laboratory registration number";
        case Enum1153.TransportContractReferenceNumber: return "Transport contract reference number";
        case Enum1153.PayeesReferenceNumber: return "Payee's reference number";
        case Enum1153.PayersReferenceNumber: return "Payer's reference number";
        case Enum1153.CreditorsReferenceNumber: return "Creditor's reference number";
        case Enum1153.DebtorsReferenceNumber: return "Debtor's reference number";
        case Enum1153.JointVentureReferenceNumber: return "Joint venture reference number";
        case Enum1153.ChamberCommerceRegistrationNumber: return "Chamber of Commerce registration number";
        case Enum1153.TaxRegistrationNumber: return "Tax registration number";
        case Enum1153.WoolIdentificationNumber: return "Wool identification number";
        case Enum1153.WoolTaxReferenceNumber: return "Wool tax reference number";
        case Enum1153.MeatProcessingEstablishmentRegistrationNumber: return "Meat processing establishment registration number";
        case Enum1153.QuarantineTreatmentStatusReferenceNumber: return "Quarantine/treatment status reference number";
        case Enum1153.RequestForQuoteNumber: return "Request for quote number";
        case Enum1153.ManualProcessingAuthorityNumber: return "Manual processing authority number";
        case Enum1153.RateNoteNumber: return "Rate note number";
        case Enum1153.FreightForwarderNumber: return "Freight Forwarder number";
        case Enum1153.CustomsReleaseCode: return "Customs release code";
        case Enum1153.ComplianceCodeNumber: return "Compliance code number";
        case Enum1153.DepartmentTransportationBondNumber: return "Department of transportation bond number";
        case Enum1153.ExportEstablishmentNumber: return "Export establishment number";
        case Enum1153.CertificateConformity: return "Certificate of conformity";
        case Enum1153.MinisterialCertificateHomologation: return "Ministerial certificate of homologation";
        case Enum1153.PreviousDeliveryInstructionNumber: return "Previous delivery instruction number";
        case Enum1153.PassportNumber: return "Passport number";
        case Enum1153.CommonTransactionReferenceNumber: return "Common transaction reference number";
        case Enum1153.BanksCommonTransactionReferenceNumber: return "Bank's common transaction reference number";
        case Enum1153.CustomersIndividualTransactionReferenceNumber: return "Customer's individual transaction reference number";
        case Enum1153.BanksIndividualTransactionReferenceNumber: return "Bank's individual transaction reference number";
        case Enum1153.CustomersCommonTransactionReferenceNumber: return "Customer's common transaction reference number";
        case Enum1153.IndividualTransactionReferenceNumber: return "Individual transaction reference number";
        case Enum1153.ProductSourcingAgreementNumber: return "Product sourcing agreement number";
        case Enum1153.CustomsTranshipmentNumber: return "Customs transhipment number";
        case Enum1153.CustomsPreferenceInquiryNumber: return "Customs preference inquiry number";
        case Enum1153.PackingPlantNumber: return "Packing plant number";
        case Enum1153.OriginalCertificateNumber: return "Original certificate number";
        case Enum1153.ProcessingPlantNumber: return "Processing plant number";
        case Enum1153.SlaughterPlantNumber: return "Slaughter plant number";
        case Enum1153.ChargeCardAccountNumber: return "Charge card account number";
        case Enum1153.EventReferenceNumber: return "Event reference number";
        case Enum1153.TransportSectionReferenceNumber: return "Transport section reference number";
        case Enum1153.ReferredProductForMechanicalAnalysis: return "Referred product for mechanical analysis";
        case Enum1153.ReferredProductForChemicalAnalysis: return "Referred product for chemical analysis";
        case Enum1153.ConsolidatedInvoiceNumber: return "Consolidated invoice number";
        case Enum1153.PartReferenceIndicatorInADrawing: return "Part reference indicator in a drawing";
        case Enum1153.USCodeFederalRegulationsCfr: return "U.S. Code of Federal Regulations (CFR)";
        case Enum1153.PurchasingActivityClauseNumber: return "Purchasing activity clause number";
        case Enum1153.USDefenseFederalAcquisitionRegulationSupplement: return "U.S. Defense Federal Acquisition Regulation Supplement";
        case Enum1153.AgencyClauseNumber: return "Agency clause number";
        case Enum1153.CircularPublicationNumber: return "Circular publication number";
        case Enum1153.USFederalAcquisitionRegulation: return "U.S. Federal Acquisition Regulation";
        case Enum1153.USGeneralServicesAdministrationRegulation: return "U.S. General Services Administration Regulation";
        case Enum1153.USFederalInformationResourcesManagementRegulation: return "U.S. Federal Information Resources Management Regulation";
        case Enum1153.Paragraph: return "Paragraph";
        case Enum1153.SpecialInstructionsNumber: return "Special instructions number";
        case Enum1153.SiteSpecificProceduresTermsAndConditionsNumber: return "Site specific procedures, terms, and conditions number";
        case Enum1153.MasterSolicitationProceduresTermsAndConditions: return "Master solicitation procedures, terms, and conditions";
        case Enum1153.USDepartmentVeteransAffairsAcquisitionRegulation: return "U.S. Department of Veterans Affairs Acquisition Regulation";
        case Enum1153.MilitaryInterdepartmentalPurchaseRequestMiprNumber: return "Military Interdepartmental Purchase Request (MIPR) number";
        case Enum1153.ForeignMilitarySalesNumber: return "Foreign military sales number";
        case Enum1153.DefensePrioritiesAllocationSystemPriorityRating: return "Defense priorities allocation system priority rating";
        case Enum1153.WageDeterminationNumber: return "Wage determination number";
        case Enum1153.AgreementNumber: return "Agreement number";
        case Enum1153.StandardIndustryClassificationSicNumber: return "Standard Industry Classification (SIC) number";
        case Enum1153.EndItemNumber: return "End item number";
        case Enum1153.FederalSupplyScheduleItemNumber: return "Federal supply schedule item number";
        case Enum1153.TechnicalDocumentNumber: return "Technical document number";
        case Enum1153.TechnicalOrderNumber: return "Technical order number";
        case Enum1153.Suffix: return "Suffix";
        case Enum1153.TransportationAccountNumber: return "Transportation account number";
        case Enum1153.ContainerDispositionOrderReferenceNumber: return "Container disposition order reference number";
        case Enum1153.ContainerPrefix: return "Container prefix";
        case Enum1153.TransportEquipmentReturnReference: return "Transport equipment return reference";
        case Enum1153.TransportEquipmentSurveyReference: return "Transport equipment survey reference";
        case Enum1153.TransportEquipmentSurveyReportNumber: return "Transport equipment survey report number";
        case Enum1153.TransportEquipmentStuffingOrder: return "Transport equipment stuffing order";
        case Enum1153.VehicleIdentificationNumberVin: return "Vehicle Identification Number (VIN)";
        case Enum1153.GovernmentBillLading: return "Government bill of lading";
        case Enum1153.OrderingCustomersSecondReferenceNumber: return "Ordering customer's second reference number";
        case Enum1153.DirectDebitReference: return "Direct debit reference";
        case Enum1153.MeterReadingAtBeginningDelivery: return "Meter reading at the beginning of the delivery";
        case Enum1153.MeterReadingAtEndDelivery: return "Meter reading at the end of delivery";
        case Enum1153.ReplenishmentPurchaseOrderRangeStartNumber: return "Replenishment purchase order range start number";
        case Enum1153.ThirdBanksReference: return "Third bank's reference";
        case Enum1153.ActionAuthorizationNumber: return "Action authorization number";
        case Enum1153.AppropriationNumber: return "Appropriation number";
        case Enum1153.ProductChangeAuthorityNumber: return "Product change authority number";
        case Enum1153.GeneralCargoConsignmentReferenceNumber: return "General cargo consignment reference number";
        case Enum1153.CatalogueSequenceNumber: return "Catalogue sequence number";
        case Enum1153.ForwardingOrderNumber: return "Forwarding order number";
        case Enum1153.TransportEquipmentSurveyReferenceNumber: return "Transport equipment survey reference number";
        case Enum1153.LeaseContractReference: return "Lease contract reference";
        case Enum1153.TransportCostsReferenceNumber: return "Transport costs reference number";
        case Enum1153.TransportEquipmentStrippingOrder: return "Transport equipment stripping order";
        case Enum1153.PriorPolicyNumber: return "Prior policy number";
        case Enum1153.PolicyNumber: return "Policy number";
        case Enum1153.ProcurementBudgetNumber: return "Procurement budget number";
        case Enum1153.DomesticInventoryManagementCode: return "Domestic inventory management code";
        case Enum1153.CustomerReferenceNumberAssignedToPreviousBalance: return "Customer reference number assigned to previous balance of";
        case Enum1153.PreviousCreditAdviceReferenceNumber: return "Previous credit advice reference number";
        case Enum1153.ReportingFormNumber: return "Reporting form number";
        case Enum1153.AuthorizationNumberForExceptionToDangerousGoods: return "Authorization number for exception to dangerous goods";
        case Enum1153.DangerousGoodsSecurityNumber: return "Dangerous goods security number";
        case Enum1153.DangerousGoodsTransportLicenceNumber: return "Dangerous goods transport licence number";
        case Enum1153.PreviousRentalAgreementNumber: return "Previous rental agreement number";
        case Enum1153.NextRentalAgreementReasonNumber: return "Next rental agreement reason number";
        case Enum1153.ConsigneesInvoiceNumber: return "Consignee's invoice number";
        case Enum1153.MessageBatchNumber: return "Message batch number";
        case Enum1153.PreviousDeliveryScheduleNumber: return "Previous delivery schedule number";
        case Enum1153.PhysicalInventoryRecountReferenceNumber: return "Physical inventory recount reference number";
        case Enum1153.ReceivingAdviceNumber: return "Receiving advice number";
        case Enum1153.ReturnableContainerReferenceNumber: return "Returnable container reference number";
        case Enum1153.ReturnsNoticeNumber: return "Returns notice number";
        case Enum1153.SalesForecastNumber: return "Sales forecast number";
        case Enum1153.SalesReportNumber: return "Sales report number";
        case Enum1153.PreviousTaxControlNumber: return "Previous tax control number";
        case Enum1153.AgerdAerospaceGroundEquipmentRequirementDataNumber: return "AGERD (Aerospace Ground Equipment Requirement Data) number";
        case Enum1153.RegisteredCapitalReference: return "Registered capital reference";
        case Enum1153.StandardNumberInspectionDocument: return "Standard number of inspection document";
        case Enum1153.Model: return "Model";
        case Enum1153.FinancialManagementReference: return "Financial management reference";
        case Enum1153.NotificationForCollectionNumberNoticol: return "NOTIfication for COLlection number (NOTICOL)";
        case Enum1153.PreviousRequestForMeteredReadingReferenceNumber: return "Previous request for metered reading reference number";
        case Enum1153.NextRentalAgreementNumber: return "Next rental agreement number";
        case Enum1153.ReferenceNumberARequestForMeteredReading: return "Reference number of a request for metered reading";
        case Enum1153.HasteningNumber: return "Hastening number";
        case Enum1153.RepairDataRequestNumber: return "Repair data request number";
        case Enum1153.ConsumptionDataRequestNumber: return "Consumption data request number";
        case Enum1153.ProfileNumber: return "Profile number";
        case Enum1153.CaseNumber: return "Case number";
        case Enum1153.GovernmentQualityAssuranceAndControlLevelNumber: return "Government quality assurance and control level Number";
        case Enum1153.PaymentPlanReference: return "Payment plan reference";
        case Enum1153.ReplacedMeterUnitNumber: return "Replaced meter unit number";
        case Enum1153.ReplenishmentPurchaseOrderRangeEndNumber: return "Replenishment purchase order range end number";
        case Enum1153.InsurerAssignedReferenceNumber: return "Insurer assigned reference number";
        case Enum1153.CanadianExciseEntryNumber: return "Canadian excise entry number";
        case Enum1153.PremiumRateTable: return "Premium rate table";
        case Enum1153.AdviseThroughBanksReference: return "Advise through bank's reference";
        case Enum1153.UsDepartmentTransportationBondSuretyCode: return "US, Department of Transportation bond surety code";
        case Enum1153.UsFoodAndDrugAdministrationEstablishmentIndicator: return "US, Food and Drug Administration establishment indicator";
        case Enum1153.UsFederalCommunicationsCommissionFccImport: return "US, Federal Communications Commission (FCC) import";
        case Enum1153.GoodsAndServicesTaxIdentificationNumber: return "Goods and Services Tax identification number";
        case Enum1153.IntegratedLogisticSupportCrossReferenceNumber: return "Integrated logistic support cross reference number";
        case Enum1153.DepartmentNumber: return "Department number";
        case Enum1153.BuyersCatalogueNumber: return "Buyer's catalogue number";
        case Enum1153.FinancialSettlementPartysReferenceNumber: return "Financial settlement party's reference number";
        case Enum1153.StandardsVersionNumber: return "Standard's version number";
        case Enum1153.PipelineNumber: return "Pipeline number";
        case Enum1153.AccountServicingBanksReferenceNumber: return "Account servicing bank's reference number";
        case Enum1153.CompletedUnitsPaymentRequestReference: return "Completed units payment request reference";
        case Enum1153.PaymentInAdvanceRequestReference: return "Payment in advance request reference";
        case Enum1153.ParentFile: return "Parent file";
        case Enum1153.SubFile: return "Sub file";
        case Enum1153.CadFileLayerConvention: return "CAD file layer convention";
        case Enum1153.TechnicalRegulation: return "Technical regulation";
        case Enum1153.PlotFile: return "Plot file";
        case Enum1153.FileConversionJournal: return "File conversion journal";
        case Enum1153.AuthorizationNumber: return "Authorization number";
        case Enum1153.ReferenceNumberAssignedByThirdParty: return "Reference number assigned by third party";
        case Enum1153.DepositReferenceNumber: return "Deposit reference number";
        case Enum1153.NamedBanksReference: return "Named bank's reference";
        case Enum1153.DraweesReference: return "Drawee's reference";
        case Enum1153.CaseNeedPartysReference: return "Case of need party's reference";
        case Enum1153.CollectingBanksReference: return "Collecting bank's reference";
        case Enum1153.RemittingBanksReference: return "Remitting bank's reference";
        case Enum1153.PrincipalsBankReference: return "Principal's bank reference";
        case Enum1153.PresentingBanksReference: return "Presenting bank's reference";
        case Enum1153.ConsigneesReference: return "Consignee's reference";
        case Enum1153.FinancialTransactionReferenceNumber: return "Financial transaction reference number";
        case Enum1153.CreditReferenceNumber: return "Credit reference number";
        case Enum1153.ReceivingBanksAuthorizationNumber: return "Receiving bank's authorization number";
        case Enum1153.ClearingReference: return "Clearing reference";
        case Enum1153.SendingBanksReferenceNumber: return "Sending bank's reference number";
        case Enum1153.DocumentaryPaymentReference: return "Documentary payment reference";
        case Enum1153.AccountingFileReference: return "Accounting file reference";
        case Enum1153.SendersFileReferenceNumber: return "Sender's file reference number";
        case Enum1153.ReceiversFileReferenceNumber: return "Receiver's file reference number";
        case Enum1153.SourceDocumentInternalReference: return "Source document internal reference";
        case Enum1153.PrincipalsReference: return "Principal's reference";
        case Enum1153.DebitReferenceNumber: return "Debit reference number";
        case Enum1153.Calendar: return "Calendar";
        case Enum1153.WorkShift: return "Work shift";
        case Enum1153.WorkBreakdownStructure: return "Work breakdown structure";
        case Enum1153.OrganisationBreakdownStructure: return "Organisation breakdown structure";
        case Enum1153.WorkTaskChargeNumber: return "Work task charge number";
        case Enum1153.FunctionalWorkGroup: return "Functional work group";
        case Enum1153.WorkTeam: return "Work team";
        case Enum1153.Department: return "Department";
        case Enum1153.StatementWork: return "Statement of work";
        case Enum1153.WorkPackage: return "Work package";
        case Enum1153.PlanningPackage: return "Planning package";
        case Enum1153.CostAccount: return "Cost account";
        case Enum1153.WorkOrder: return "Work order";
        case Enum1153.TransportationControlNumberTcn: return "Transportation Control Number (TCN)";
        case Enum1153.ConstraintNotation: return "Constraint notation";
        case Enum1153.EtermsReference: return "ETERMS reference";
        case Enum1153.ImplementationVersionNumber: return "Implementation version number";
        case Enum1153.AccountsReceivableNumber: return " Accounts receivable number";
        case Enum1153.IncorporatedLegalReference: return "Incorporated legal reference";
        case Enum1153.PaymentInstalmentReferenceNumber: return "Payment instalment reference number";
        case Enum1153.EquipmentOwnerReferenceNumber: return "Equipment owner reference number";
        case Enum1153.CedentsClaimNumber: return "Cedent's claim number";
        case Enum1153.ReinsurersClaimNumber: return "Reinsurer's claim number";
        case Enum1153.PriceSalesCatalogueResponseReferenceNumber: return "Price/sales catalogue response reference number";
        case Enum1153.GeneralPurposeMessageReferenceNumber: return "General purpose message reference number";
        case Enum1153.InvoicingDataSheetReferenceNumber: return "Invoicing data sheet reference number";
        case Enum1153.InventoryReportReferenceNumber: return "Inventory report reference number";
        case Enum1153.CeilingFormulaReferenceNumber: return "Ceiling formula reference number";
        case Enum1153.PriceVariationFormulaReferenceNumber: return "Price variation formula reference number";
        case Enum1153.ReferenceToAccountServicingBanksMessage: return "Reference to account servicing bank's message";
        case Enum1153.PartySequenceNumber: return "Party sequence number";
        case Enum1153.PurchasersRequestReference: return "Purchaser's request reference";
        case Enum1153.ContractorRequestReference: return "Contractor request reference";
        case Enum1153.AccidentReferenceNumber: return "Accident reference number";
        case Enum1153.CommercialAccountSummaryReferenceNumber: return "Commercial account summary reference number";
        case Enum1153.ContractBreakdownReference: return "Contract breakdown reference";
        case Enum1153.ContractorRegistrationNumber: return "Contractor registration number";
        case Enum1153.ApplicableCoefficientIdentificationNumber: return "Applicable coefficient identification number";
        case Enum1153.SpecialBudgetAccountNumber: return "Special budget account number";
        case Enum1153.AuthorisationForRepairReference: return "Authorisation for repair reference";
        case Enum1153.ManufacturerDefinedRepairRatesReference: return "Manufacturer defined repair rates reference";
        case Enum1153.OriginalSubmitterLogNumber: return "Original submitter log number";
        case Enum1153.OriginalSubmitterParentDataMaintenanceRequestDmr: return "Original submitter, parent Data Maintenance Request (DMR)";
        case Enum1153.OriginalSubmitterChildDataMaintenanceRequestDmr: return "Original submitter, child Data Maintenance Request (DMR)";
        case Enum1153.EntryPointAssessmentLogNumber: return "Entry point assessment log number";
        case Enum1153.EntryPointAssessmentLogNumberParentDmr: return "Entry point assessment log number, parent DMR";
        case Enum1153.EntryPointAssessmentLogNumberChildDmr: return "Entry point assessment log number, child DMR";
        case Enum1153.DataStructureTag: return "Data structure tag";
        case Enum1153.CentralSecretariatLogNumber: return "Central secretariat log number";
        case Enum1153.CentralSecretariatLogNumberParentDataMaintenance: return "Central secretariat log number, parent Data Maintenance";
        case Enum1153.CentralSecretariatLogNumberChildDataMaintenance: return "Central secretariat log number, child Data Maintenance";
        case Enum1153.InternationalAssessmentLogNumber: return "International assessment log number";
        case Enum1153.InternationalAssessmentLogNumberParentData: return "International assessment log number, parent Data";
        case Enum1153.InternationalAssessmentLogNumberChildDataMaintenance: return "International assessment log number, child Data Maintenance";
        case Enum1153.StatusReportNumber: return "Status report number";
        case Enum1153.MessageDesignGroupNumber: return "Message design group number";
        case Enum1153.UsCustomsServiceUscsEntryCode: return "US Customs Service (USCS) entry code";
        case Enum1153.BeginningJobSequenceNumber: return "Beginning job sequence number";
        case Enum1153.SendersClauseNumber: return "Sender's clause number";
        case Enum1153.DunAndBradstreetCanadas8DigitStandardIndustrial: return "Dun and Bradstreet Canada's 8 digit Standard Industrial";
        case Enum1153.ActivitePrincipaleExerceeApeIdentifier: return "Activite Principale Exercee (APE) identifier";
        case Enum1153.DunAndBradstreetUs8DigitStandardIndustrial: return "Dun and Bradstreet US 8 digit Standard Industrial";
        case Enum1153.NomenclatureActivityClassificationEconomyNace: return "Nomenclature Activity Classification Economy (NACE)";
        case Enum1153.NormeActiviteFrancaiseNafIdentifier: return "Norme Activite Francaise (NAF) identifier";
        case Enum1153.RegisteredContractorActivityType: return "Registered contractor activity type";
        case Enum1153.StatisticBundesAmtSbaIdentifier: return "Statistic Bundes Amt (SBA) identifier";
        case Enum1153.StateOrProvinceAssignedEntityIdentification: return "State or province assigned entity identification";
        case Enum1153.InstituteSecurityAndFutureMarketDevelopmentIsfmd: return "Institute of Security and Future Market Development (ISFMD)";
        case Enum1153.FileIdentificationNumber: return "File identification number";
        case Enum1153.BankruptcyProcedureNumber: return "Bankruptcy procedure number";
        case Enum1153.NationalGovernmentBusinessIdentificationNumber: return "National government business identification number";
        case Enum1153.PriorDataUniversalNumberSystemDunsNumber: return "Prior Data Universal Number System (DUNS) number";
        case Enum1153.CompaniesRegistryOfficeCroNumber: return "Companies Registry Office (CRO) number";
        case Enum1153.CostaRicanJudicialNumber: return "Costa Rican judicial number";
        case Enum1153.NumeroDeIdentificacionTributariaNit: return "Numero de Identificacion Tributaria (NIT)";
        case Enum1153.PatronNumber: return "Patron number";
        case Enum1153.RegistroInformacionFiscalRifNumber: return "Registro Informacion Fiscal (RIF) number";
        case Enum1153.RegistroUnicoDeContribuyenteRucNumber: return "Registro Unico de Contribuyente (RUC) number";
        case Enum1153.TokyoShokoResearchTsrBusinessIdentifier: return "Tokyo SHOKO Research (TSR) business identifier";
        case Enum1153.PersonalIdentityCardNumber: return "Personal identity card number";
        case Enum1153.SystemeInformatiquePourLeRepertoireDesEntreprises: return "Systeme Informatique pour le Repertoire des ENtreprises";
        case Enum1153.SystemeInformatiquePourLeRepertoireDesEtablissements: return "Systeme Informatique pour le Repertoire des ETablissements";
        case Enum1153.PublicationIssueNumber: return "Publication issue number";
        case Enum1153.OriginalFilingNumber: return "Original filing number";
        case Enum1153.DocumentPageIdentifier: return "Document page identifier";
        case Enum1153.PublicFilingRegistrationNumber: return "Public filing registration number";
        case Enum1153.RegiristoFederalDeContribuyentes: return "Regiristo Federal de Contribuyentes";
        case Enum1153.SocialSecurityNumber: return "Social security number";
        case Enum1153.DocumentVolumeNumber: return "Document volume number";
        case Enum1153.BookNumber: return "Book number";
        case Enum1153.StockExchangeCompanyIdentifier: return "Stock exchange company identifier";
        case Enum1153.ImputationAccount: return "Imputation account";
        case Enum1153.FinancialPhaseReference: return "Financial phase reference";
        case Enum1153.TechnicalPhaseReference: return "Technical phase reference";
        case Enum1153.PriorContractorRegistrationNumber: return "Prior contractor registration number";
        case Enum1153.StockAdjustmentNumber: return "Stock adjustment number";
        case Enum1153.DispensationReference: return "Dispensation reference";
        case Enum1153.InvestmentReferenceNumber: return "Investment reference number";
        case Enum1153.AssumingCompany: return "Assuming company";
        case Enum1153.BudgetChapter: return "Budget chapter";
        case Enum1153.DutyFreeProductsSecurityNumber: return "Duty free products security number";
        case Enum1153.DutyFreeProductsReceiptAuthorisationNumber: return "Duty free products receipt authorisation number";
        case Enum1153.PartyInformationMessageReference: return "Party information message reference";
        case Enum1153.FormalStatementReference: return "Formal statement reference";
        case Enum1153.ProofDeliveryReferenceNumber: return "Proof of delivery reference number";
        case Enum1153.SuppliersCreditClaimReferenceNumber: return "Supplier's credit claim reference number";
        case Enum1153.PictureActualProduct: return "Picture of actual product";
        case Enum1153.PictureAGenericProduct: return "Picture of a generic product";
        case Enum1153.TradingPartnerIdentificationNumber: return "Trading partner identification number";
        case Enum1153.PriorTradingPartnerIdentificationNumber: return "Prior trading partner identification number";
        case Enum1153.Password: return "Password";
        case Enum1153.FormalReportNumber: return "Formal report number";
        case Enum1153.FundAccountNumber: return "Fund account number";
        case Enum1153.SafeCustodyNumber: return "Safe custody number";
        case Enum1153.MasterAccountNumber: return "Master account number";
        case Enum1153.GroupReferenceNumber: return "Group reference number";
        case Enum1153.AccountingTransmissionNumber: return "Accounting transmission number";
        case Enum1153.ProductDataFileNumber: return "Product data file number";
        case Enum1153.CadastroGeralDoContribuinteCgc: return "Cadastro Geral do Contribuinte (CGC)";
        case Enum1153.ForeignResidentIdentificationNumber: return "Foreign resident identification number";
        case Enum1153.CdRom: return "CD-ROM";
        case Enum1153.PhysicalMedium: return "Physical medium";
        case Enum1153.FinancialCancellationReferenceNumber: return "Financial cancellation reference number";
        case Enum1153.PurchaseForExportCustomsAgreementNumber: return "Purchase for export Customs agreement number";
        case Enum1153.JudgmentNumber: return "Judgment number";
        case Enum1153.SecretariatNumber: return "Secretariat number";
        case Enum1153.PreviousBankingStatusMessageReference: return "Previous banking status message reference";
        case Enum1153.LastReceivedBankingStatusMessageReference: return "Last received banking status message reference";
        case Enum1153.BanksDocumentaryProcedureReference: return "Bank's documentary procedure reference";
        case Enum1153.CustomersDocumentaryProcedureReference: return "Customer's documentary procedure reference";
        case Enum1153.SafeDepositBoxNumber: return "Safe deposit box number";
        case Enum1153.ReceivingBankgiroNumber: return "Receiving Bankgiro number";
        case Enum1153.SendingBankgiroNumber: return "Sending Bankgiro number";
        case Enum1153.BankgiroReference: return "Bankgiro reference";
        case Enum1153.GuaranteeNumber: return "Guarantee number";
        case Enum1153.CollectionInstrumentNumber: return "Collection instrument number";
        case Enum1153.ConvertedPostgiroNumber: return "Converted Postgiro number";
        case Enum1153.CostCentreAlignmentNumber: return "Cost centre alignment number";
        case Enum1153.KamerVanKoophandelKvkNumber: return "Kamer Van Koophandel (KVK) number";
        case Enum1153.InstitutBelgoLuxembourgeoisDeCodificationIblcNumber: return "Institut Belgo-Luxembourgeois de Codification (IBLC) number";
        case Enum1153.ExternalObjectReference: return "External object reference";
        case Enum1153.ExceptionalTransportAuthorisationNumber: return "Exceptional transport authorisation number";
        case Enum1153.ClaveUnicaDeIdentificacionTributariaCuit: return "Clave Unica de Identificacion Tributaria (CUIT)";
        case Enum1153.RegistroUnicoTributarioRut: return "Registro Unico Tributario (RUT)";
        case Enum1153.FlatRackContainerBundleIdentificationNumber: return "Flat rack container bundle identification number";
        case Enum1153.TransportEquipmentAcceptanceOrderReference: return "Transport equipment acceptance order reference";
        case Enum1153.TransportEquipmentReleaseOrderReference: return "Transport equipment release order reference";
        case Enum1153.ShipsStayReferenceNumber: return "Ship's stay reference number";
        case Enum1153.AuthorizationToMeetCompetitionNumber: return " Authorization to meet competition number";
        case Enum1153.PlacePositioningReference: return "Place of positioning reference";
        case Enum1153.PartyReference: return "Party reference";
        case Enum1153.IssuedPrescriptionIdentification: return "Issued prescription identification";
        case Enum1153.CollectionReference: return "Collection reference";
        case Enum1153.TravelService: return "Travel service";
        case Enum1153.ConsignmentStockContract: return "Consignment stock contract";
        case Enum1153.ImportersLetterCreditReference: return "Importer's letter of credit reference";
        case Enum1153.PerformedPrescriptionIdentification: return "Performed prescription identification";
        case Enum1153.ImageReference: return "Image reference";
        case Enum1153.ProposedPurchaseOrderReferenceNumber: return "Proposed purchase order reference number";
        case Enum1153.ApplicationForFinancialSupportReferenceNumber: return "Application for financial support reference number";
        case Enum1153.ManufacturingQualityAgreementNumber: return "Manufacturing quality agreement number";
        case Enum1153.SoftwareEditorReference: return "Software editor reference";
        case Enum1153.SoftwareReference: return "Software reference";
        case Enum1153.SoftwareQualityReference: return "Software quality reference";
        case Enum1153.ConsolidatedOrdersReference: return "Consolidated orders' reference";
        case Enum1153.CustomsBindingRulingNumber: return "Customs binding ruling number";
        case Enum1153.CustomsNonBindingRulingNumber: return "Customs non-binding ruling number";
        case Enum1153.DeliveryRouteReference: return "Delivery route reference";
        case Enum1153.NetAreaSupplierReference: return "Net area supplier reference";
        case Enum1153.TimeSeriesReference: return "Time series reference";
        case Enum1153.ConnectingPointToCentralGrid: return "Connecting point to central grid";
        case Enum1153.MarketingPlanIdentificationNumberMpin: return "Marketing plan identification number (MPIN)";
        case Enum1153.EntityReferenceNumberPrevious: return "Entity reference number, previous";
        case Enum1153.InternationalStandardIndustrialClassificationIsic: return "International Standard Industrial Classification (ISIC)";
        case Enum1153.CustomsPreApprovalRulingNumber: return "Customs pre-approval ruling number";
        case Enum1153.AccountPayableNumber: return " Account payable number";
        case Enum1153.FirstFinancialInstitutionsTransactionReference: return "First financial institution's transaction reference";
        case Enum1153.ProductCharacteristicsDirectory: return "Product characteristics directory";
        case Enum1153.SuppliersCustomerReferenceNumber: return "Supplier's customer reference number";
        case Enum1153.InventoryReportRequestNumber: return "Inventory report request number";
        case Enum1153.MeteringPoint: return "Metering point";
        case Enum1153.PassengerReservationNumber: return "Passenger reservation number";
        case Enum1153.SlaughterhouseApprovalNumber: return "Slaughterhouse approval number";
        case Enum1153.MeatCuttingPlantApprovalNumber: return "Meat cutting plant approval number";
        case Enum1153.CustomerTravelServiceIdentifier: return "Customer travel service identifier";
        case Enum1153.ExportControlClassificationNumber: return "Export control classification number";
        case Enum1153.BrokerReference3: return "Broker reference 3";
        case Enum1153.ConsignmentInformation: return "Consignment information";
        case Enum1153.GoodsItemInformation: return "Goods item information";
        case Enum1153.DangerousGoodsInformation: return "Dangerous Goods information";
        case Enum1153.PilotageServicesExemptionNumber: return "Pilotage services exemption number";
        case Enum1153.PersonRegistrationNumber: return "Person registration number";
        case Enum1153.PlacePackingApprovalNumber: return "Place of packing approval number";
        case Enum1153.OriginalMandateReference: return "Original Mandate Reference";
        case Enum1153.MandateReference: return "Mandate Reference";
        case Enum1153.ReservationStationIndentifier: return "Reservation station indentifier";
        case Enum1153.UniqueGoodsShipmentIdentifier: return "Unique goods shipment identifier";
        case Enum1153.FrameworkAgreementNumber: return "Framework Agreement Number";
        case Enum1153.HashValue: return "Hash value";
        case Enum1153.MovementReferenceNumber: return "Movement reference number";
        case Enum1153.EconomicOperatorsRegistrationAndIdentificationNumber: return "Economic Operators Registration and Identification Number";
        case Enum1153.LocalReferenceNumber: return "Local Reference Number";
        case Enum1153.RateCodeNumber: return "Rate code number";
        case Enum1153.AirWaybillNumber: return "Air waybill number";
        case Enum1153.DocumentaryCreditAmendmentNumber: return "Documentary credit amendment number";
        case Enum1153.AdvisingBanksReference: return "Advising bank's reference";
        case Enum1153.CostCentre: return "Cost centre";
        case Enum1153.WorkItemQuantityDetermination: return "Work item quantity determination";
        case Enum1153.InternalDataProcessNumber: return "Internal data process number";
        case Enum1153.CategoryWorkReference: return "Category of work reference";
        case Enum1153.PolicyFormNumber: return "Policy form number";
        case Enum1153.NetArea: return "Net area";
        case Enum1153.ServiceProvider: return "Service provider";
        case Enum1153.ErrorPosition: return "Error position";
        case Enum1153.ServiceCategoryReference: return "Service category reference";
        case Enum1153.ConnectedLocation: return "Connected location";
        case Enum1153.RelatedParty: return "Related party";
        case Enum1153.LatestAccountingEntryRecordReference: return "Latest accounting entry record reference";
        case Enum1153.AccountingEntry: return "Accounting entry";
        case Enum1153.DocumentReferenceOriginal: return "Document reference, original";
        case Enum1153.HygienicCertificateNumberNational: return "Hygienic Certificate number, national";
        case Enum1153.AdministrativeReferenceCode: return "Administrative Reference Code";
        case Enum1153.PickUpSheetNumber: return "Pick-up sheet number";
        case Enum1153.PhoneNumber: return "Phone number";
        case Enum1153.BuyersFundNumber: return "Buyer's fund number";
        case Enum1153.CompanyTradingAccountNumber: return "Company trading account number";
        case Enum1153.ReservedGoodsIdentifier: return "Reserved goods identifier";
        case Enum1153.HandlingAndMovementReferenceNumber: return "Handling and movement reference number";
        case Enum1153.InstructionToDespatchReferenceNumber: return "Instruction to despatch reference number";
        case Enum1153.InstructionForReturnsNumber: return "Instruction for returns number";
        case Enum1153.MeteredServicesConsumptionReportNumber: return "Metered services consumption report number";
        case Enum1153.OrderStatusEnquiryNumber: return "Order status enquiry number";
        case Enum1153.FirmBookingReferenceNumber: return "Firm booking reference number";
        case Enum1153.ProductInquiryNumber: return "Product inquiry number";
        case Enum1153.SplitDeliveryNumber: return "Split delivery number";
        case Enum1153.ServiceRelationNumber: return "Service relation number";
        case Enum1153.SerialShippingContainerCode: return "Serial shipping container code";
        case Enum1153.TestSpecificationNumber: return "Test specification number";
        case Enum1153.TransportStatusReportNumber: return "Transport status report number";
        case Enum1153.ToolingContractNumber: return "Tooling contract number";
        case Enum1153.FormulaReferenceNumber: return "Formula reference number";
        case Enum1153.PreAgreementNumber: return "Pre-agreement number";
        case Enum1153.ProductCertificationNumber: return "Product certification number";
        case Enum1153.ConsignmentContractNumber: return "Consignment contract number";
        case Enum1153.ProductSpecificationReferenceNumber: return "Product specification reference number";
        case Enum1153.PayrollDeductionAdviceReference: return "Payroll deduction advice reference";
        case Enum1153.TracesPartyIdentification: return "TRACES party identification";
        case Enum1153.BeginningMeterReadingActual: return " Beginning meter reading actual";
        case Enum1153.BuyersContractNumber: return " Buyer's contract number";
        case Enum1153.BidNumber: return " Bid number";
        case Enum1153.BeginningMeterReadingEstimated: return " Beginning meter reading estimated";
        case Enum1153.HouseBillLadingNumber: return " House bill of lading number";
        case Enum1153.BillLadingNumber: return " Bill of lading number";
        case Enum1153.ConsignmentIdentifierCarrierAssigned: return " Consignment identifier, carrier assigned";
        case Enum1153.BlanketOrderNumber: return " Blanket order number";
        case Enum1153.BrokerOrSalesOfficeNumber: return " Broker or sales office number";
        case Enum1153.BatchNumberLotNumber: return " Batch number/lot number";
        case Enum1153.BatteryAndAccumulatorProducerRegistrationNumber: return "Battery and accumulator producer registration number";
        case Enum1153.BlendedWithNumber: return " Blended with number";
        case Enum1153.IataCargoAgentCassAddressNumber: return "IATA Cargo Agent CASS Address number";
        case Enum1153.MatchingEntriesBalanced: return "Matching of entries, balanced";
        case Enum1153.EntryFlagging: return "Entry flagging";
        case Enum1153.MatchingEntriesUnbalanced: return "Matching of entries, unbalanced";
        case Enum1153.DocumentReferenceInternal: return "Document reference, internal";
        case Enum1153.EuropeanValueAddedTaxIdentification: return "European Value Added Tax identification";
        case Enum1153.CostAccountingDocument: return "Cost accounting document";
        case Enum1153.GridOperatorsCustomerReferenceNumber: return "Grid operator's customer reference number";
        case Enum1153.TicketControlNumber: return "Ticket control number";
        case Enum1153.OrderShipmentGroupingReference: return "Order shipment grouping reference";
        case Enum1153.CreditNoteNumber: return " Credit note number";
        case Enum1153.CedingCompany: return "Ceding company";
        case Enum1153.DebitLetterNumber: return "Debit letter number";
        case Enum1153.ConsigneesFurtherOrder: return "Consignee's further order";
        case Enum1153.AnimalFarmLicenceNumber: return "Animal farm licence number";
        case Enum1153.ConsignorsFurtherOrder: return "Consignor's further order";
        case Enum1153.ConsigneesOrderNumber: return " Consignee's order number";
        case Enum1153.CustomerCatalogueNumber: return " Customer catalogue number";
        case Enum1153.ChequeNumber: return " Cheque number";
        case Enum1153.CheckingNumber: return "Checking number";
        case Enum1153.CreditMemoNumber: return " Credit memo number";
        case Enum1153.RoadConsignmentNoteNumber: return "Road consignment note number";
        case Enum1153.CarriersReferenceNumber: return " Carrier's reference number";
        case Enum1153.ChargesNoteDocumentAttachmentIndicator: return "Charges note document attachment indicator";
        case Enum1153.CallOffOrderNumber: return "Call off order number";
        case Enum1153.ConditionPurchaseDocumentNumber: return " Condition of purchase document number";
        case Enum1153.CustomerReferenceNumber: return " Customer reference number";
        case Enum1153.TransportMeansJourneyIdentifier: return "Transport means journey identifier";
        case Enum1153.ConditionSaleDocumentNumber: return " Condition of sale document number";
        case Enum1153.TeamAssignmentNumber: return "Team assignment number";
        case Enum1153.ContractNumber: return " Contract number";
        case Enum1153.ConsignmentIdentifierConsignorAssigned: return " Consignment identifier, consignor assigned";
        case Enum1153.ContainerOperatorsReferenceNumber: return " Container operators reference number";
        case Enum1153.PackageNumber: return " Package number";
        case Enum1153.CooperationContractNumber: return " Cooperation contract number";
        case Enum1153.DefermentApprovalNumber: return " Deferment approval number";
        case Enum1153.DebitAccountNumber: return "Debit account number";
        case Enum1153.BuyersDebtorNumber: return " Buyer's debtor number";
        case Enum1153.DistributorInvoiceNumber: return " Distributor invoice number";
        case Enum1153.DebitNoteNumber: return " Debit note number";
        case Enum1153.DocumentIdentifier: return " Document identifier";
        case Enum1153.DeliveryNoteNumber: return " Delivery note number";
        case Enum1153.DockReceiptNumber: return " Dock receipt number";
        case Enum1153.EndingMeterReadingActual: return " Ending meter reading actual";
        case Enum1153.EmbargoPermitNumber: return " Embargo permit number";
        case Enum1153.ExportDeclaration: return " Export declaration";
        case Enum1153.EndingMeterReadingEstimated: return " Ending meter reading estimated";
        case Enum1153.ElectricalAndElectronicEquipmentProducerRegistration: return "Electrical and electronic equipment producer registration";
        case Enum1153.EmployersIdentificationNumber: return " Employer's identification number";
        case Enum1153.EmbargoNumber: return " Embargo number";
        case Enum1153.EquipmentNumber: return " Equipment number";
        case Enum1153.ContainerEquipmentReceiptNumber: return " Container/equipment receipt number";
        case Enum1153.ExportersReferenceNumber: return "Exporter's reference number";
        case Enum1153.ExcessTransportationNumber: return " Excess transportation number";
        case Enum1153.ExportPermitIdentifier: return " Export permit identifier";
        case Enum1153.FiscalNumber: return " Fiscal number";
        case Enum1153.ConsignmentIdentifierFreightForwarderAssigned: return " Consignment identifier, freight forwarder assigned";
        case Enum1153.FileLineIdentifier: return " File line identifier";
        case Enum1153.FlowReferenceNumber: return "Flow reference number";
        case Enum1153.FreightBillNumber: return " Freight bill number";
        case Enum1153.ForeignExchange: return " Foreign exchange";
        case Enum1153.FinalSequenceNumber: return " Final sequence number";
        case Enum1153.FreeZoneIdentifier: return " Free zone identifier";
        case Enum1153.FileVersionNumber: return " File version number";
        case Enum1153.ForeignExchangeContractNumber: return " Foreign exchange contract number";
        case Enum1153.StandardsNumber: return " Standard's number";
        case Enum1153.GovernmentContractNumber: return " Government contract number";
        case Enum1153.StandardsCodeNumber: return " Standard's code number";
        case Enum1153.GeneralDeclarationNumber: return "General declaration number";
        case Enum1153.GovernmentReferenceNumber: return " Government reference number";
        case Enum1153.HarmonisedSystemNumber: return " Harmonised system number";
        case Enum1153.HouseWaybillNumber: return "House waybill number";
        case Enum1153.InternalVendorNumber: return " Internal vendor number";
        case Enum1153.InBondNumber: return " In bond number";
        case Enum1153.IataCargoAgentCodeNumber: return "IATA cargo agent code number";
        case Enum1153.InsuranceCertificateReferenceNumber: return "Insurance certificate reference number";
        case Enum1153.InsuranceContractReferenceNumber: return "Insurance contract reference number";
        case Enum1153.InitialSampleInspectionReportNumber: return " Initial sample inspection report number";
        case Enum1153.InternalOrderNumber: return " Internal order number";
        case Enum1153.IntermediaryBroker: return "Intermediary broker";
        case Enum1153.InterchangeNumberNew: return "Interchange number new";
        case Enum1153.InterchangeNumberOld: return "Interchange number old";
        case Enum1153.ImportPermitIdentifier: return " Import permit identifier";
        case Enum1153.InvoiceNumberSuffix: return " Invoice number suffix";
        case Enum1153.InternalCustomerNumber: return " Internal customer number";
        case Enum1153.InvoiceDocumentIdentifier: return " Invoice document identifier";
        case Enum1153.JobNumber: return " Job number";
        case Enum1153.EndingJobSequenceNumber: return " Ending job sequence number";
        case Enum1153.ShippingLabelSerialNumber: return " Shipping label serial number";
        case Enum1153.LoadingAuthorisationIdentifier: return "Loading authorisation identifier";
        case Enum1153.LowerNumberInRange: return "Lower number in range";
        case Enum1153.Lockbox: return " Lockbox";
        case Enum1153.LetterCreditNumber: return " Letter of credit number";
        case Enum1153.DocumentLineIdentifier: return " Document line identifier";
        case Enum1153.LoadPlanningNumber: return " Load planning number";
        case Enum1153.ReservationOfficeIdentifier: return "Reservation office identifier";
        case Enum1153.BarCodedLabelSerialNumber: return " Bar coded label serial number";
        case Enum1153.ShipNoticeManifestNumber: return " Ship notice/manifest number";
        case Enum1153.MasterBillLadingNumber: return " Master bill of lading number";
        case Enum1153.ManufacturersPartNumber: return " Manufacturer's part number";
        case Enum1153.MeterUnitNumber: return " Meter unit number";
        case Enum1153.ManufacturingOrderNumber: return " Manufacturing order number";
        case Enum1153.MessageRecipient: return " Message recipient";
        case Enum1153.MailingReferenceNumber: return "Mailing reference number";
        case Enum1153.MessageSender: return " Message sender";
        case Enum1153.ManufacturersMaterialSafetyDataSheetNumber: return "Manufacturer's material safety data sheet number";
        case Enum1153.MasterAirWaybillNumber: return "Master air waybill number";
        case Enum1153.NorthAmericanHazardousGoodsClassificationNumber: return " North American hazardous goods classification number";
        case Enum1153.NotaFiscal: return " Nota Fiscal";
        case Enum1153.CurrentInvoiceNumber: return " Current invoice number";
        case Enum1153.PreviousInvoiceNumber: return " Previous invoice number";
        case Enum1153.OrderDocumentIdentifierBuyerAssigned: return " Order document identifier, buyer assigned";
        case Enum1153.OriginalPurchaseOrder: return " Original purchase order";
        case Enum1153.GeneralOrderNumber: return " General order number";
        case Enum1153.PayersFinancialInstitutionAccountNumber: return " Payer's financial institution account number";
        case Enum1153.ProductionCode: return " Production code";
        case Enum1153.PromotionDealNumber: return " Promotion deal number";
        case Enum1153.PlantNumber: return " Plant number";
        case Enum1153.PrimeContractorContractNumber: return " Prime contractor contract number";
        case Enum1153.PriceListVersionNumber: return " Price list version number";
        case Enum1153.PackingListNumber: return " Packing list number";
        case Enum1153.PriceListNumber: return " Price list number";
        case Enum1153.PurchaseOrderResponseNumber: return "Purchase order response number";
        case Enum1153.PurchaseOrderChangeNumber: return " Purchase order change number";
        case Enum1153.PaymentReference: return " Payment reference";
        case Enum1153.PriceQuoteNumber: return " Price quote number";
        case Enum1153.PurchaseOrderNumberSuffix: return " Purchase order number suffix";
        case Enum1153.PriorPurchaseOrderNumber: return " Prior purchase order number";
        case Enum1153.PayeesFinancialInstitutionAccountNumber: return " Payee's financial institution account number";
        case Enum1153.RemittanceAdviceNumber: return " Remittance advice number";
        case Enum1153.RailRoadRoutingCode: return " Rail/road routing code";
        case Enum1153.RailwayConsignmentNoteNumber: return "Railway consignment note number";
        case Enum1153.ReleaseNumber: return " Release number";
        case Enum1153.ConsignmentReceiptIdentifier: return "Consignment receipt identifier";
        case Enum1153.ExportReferenceNumber: return " Export reference number";
        case Enum1153.PayersFinancialInstitutionTransitRoutingNoAch: return " Payer's financial institution transit routing No.(ACH";
        case Enum1153.PayeesFinancialInstitutionTransitRoutingNo: return " Payee's financial institution transit routing No.";
        case Enum1153.SalesPersonNumber: return " Sales person number";
        case Enum1153.SalesRegionNumber: return " Sales region number";
        case Enum1153.SalesDepartmentNumber: return " Sales department number";
        case Enum1153.SerialNumber: return " Serial number";
        case Enum1153.AllocatedSeat: return "Allocated seat";
        case Enum1153.ShipFrom: return " Ship from";
        case Enum1153.PreviousHighestScheduleNumber: return " Previous highest schedule number";
        case Enum1153.SidShippersIdentifyingNumberForShipment: return " SID (Shipper's identifying number for shipment)";
        case Enum1153.SalesOfficeNumber: return " Sales office number";
        case Enum1153.TransportEquipmentSealIdentifier: return " Transport equipment seal identifier";
        case Enum1153.ScanLine: return " Scan line";
        case Enum1153.EquipmentSequenceNumber: return " Equipment sequence number";
        case Enum1153.ShipmentReferenceNumber: return "Shipment reference number";
        case Enum1153.SellersReferenceNumber: return " Sellers reference number";
        case Enum1153.StationReferenceNumber: return "Station reference number";
        case Enum1153.SwapOrderNumber: return " Swap order number";
        case Enum1153.SpecificationNumber: return " Specification number";
        case Enum1153.TruckersBillLading: return " Trucker's bill of lading";
        case Enum1153.TerminalOperatorsConsignmentReference: return "Terminal operator's consignment reference";
        case Enum1153.TelexMessageNumber: return " Telex message number";
        case Enum1153.TransferNumber: return " Transfer number";
        case Enum1153.TirCarnetNumber: return " TIR carnet number";
        case Enum1153.TransportInstructionNumber: return "Transport instruction number";
        case Enum1153.TaxExemptionLicenceNumber: return " Tax exemption licence number";
        case Enum1153.TransactionReferenceNumber: return " Transaction reference number";
        case Enum1153.TestReportNumber: return " Test report number";
        case Enum1153.UpperNumberRange: return "Upper number of range";
        case Enum1153.UltimateCustomersReferenceNumber: return " Ultimate customer's reference number";
        case Enum1153.UniqueConsignmentReferenceNumber: return "Unique consignment reference number";
        case Enum1153.UnitedNationsDangerousGoodsIdentifier: return " United Nations Dangerous Goods identifier";
        case Enum1153.UltimateCustomersOrderNumber: return " Ultimate customer's order number";
        case Enum1153.UniformResourceIdentifier: return "Uniform Resource Identifier";
        case Enum1153.VatRegistrationNumber: return " VAT registration number";
        case Enum1153.VendorContractNumber: return " Vendor contract number";
        case Enum1153.TransportEquipmentGrossMassVerificationReference: return "Transport equipment gross mass verification reference";
        case Enum1153.VesselIdentifier: return " Vessel identifier";
        case Enum1153.OrderNumberVendor: return " Order number (vendor)";
        case Enum1153.VoyageNumber: return "Voyage number";
        case Enum1153.TransportEquipmentGrossMassVerificationOrderReference: return "Transport equipment gross mass verification order reference";
        case Enum1153.VendorProductNumber: return " Vendor product number";
        case Enum1153.VendorIdNumber: return " Vendor ID number";
        case Enum1153.VendorOrderNumberSuffix: return " Vendor order number suffix";
        case Enum1153.MotorVehicleIdentificationNumber: return " Motor vehicle identification number";
        case Enum1153.VoucherNumber: return " Voucher number";
        case Enum1153.WarehouseEntryNumber: return " Warehouse entry number";
        case Enum1153.WeightAgreementNumber: return " Weight agreement number";
        case Enum1153.WellNumber: return " Well number";
        case Enum1153.WarehouseReceiptNumber: return " Warehouse receipt number";
        case Enum1153.WarehouseStorageLocationNumber: return " Warehouse storage location number";
        case Enum1153.RailWaybillNumber: return " Rail waybill number";
        case Enum1153.CompanyPlaceRegistrationNumber: return " Company/place registration number";
        case Enum1153.CargoControlNumber: return " Cargo control number";
        case Enum1153.PreviousCargoControlNumber: return " Previous cargo control number";
        case Enum1153.MutuallyDefinedReferenceNumber: return "Mutually defined reference number";
    }
}
